window.webtrekkConfig = window.webtrekkConfig || {
  trackId: '602039762736393',
  trackDomain: 'rai-italia01.wt-eu02.net',
  domain: 'www.dummydomain-donotchange.com',
  cookie: '3',
  forceHTTPS: true,
  mediaCode: 'wt_mc',
  contentId: '',
  tabBrowsing: false,
  execCDB: false,
  execRTA: false,
  safetag: {
    async: true,
    timeout: 2000,
    /** Load SafeTag from Webtrekk Server */
    safetagDomain: 'responder.wt-safetag.com',
    safetagId: '602039762736393',
    /** Load SafeTag from Customer Server */
    // customDomain: "www.domain.de",
    // customPath: "javascripts/webtrekk_safetag.js",
    option: {},
  },
};

/**
 ************ Don't change anything beyond this line ************
 ********************* Start webtrekk_v4.js *********************
 */
('use strict');
(function (l) {
  l.webtrekkUnloadObjects = l.webtrekkUnloadObjects || [];
  l.webtrekkLinktrackObjects = l.webtrekkLinktrackObjects || [];
  var J = function (a) {
      a.getJSON = function (a) {
        if (
          'string' === typeof a &&
          a &&
          '{' === a.charAt(0) &&
          '}' === a.charAt(a.length - 1)
        )
          try {
            a = a
              .replace(/'/g, '"')
              .replace(/(['"])?([a-zA-Z0-9]+)(['"])?\s?:/g, '"$2":');
            var b =
              'object' === typeof JSON && 'function' === typeof JSON.parse
                ? JSON.parse(a)
                : /^[\],:{}\s]*$/.test(
                      a
                        .replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
                        .replace(
                          /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                          ']',
                        )
                        .replace(/(?:^|:|,)(?:\s*\[)+/g, ''),
                    )
                  ? new Function('return ' + a)()
                  : null;
            if ('object' === typeof b) return b;
          } catch (d) {}
        return null;
      };
      a.parseJSON = function (c, b) {
        for (var d in c) {
          var f = d;
          if ('object' === typeof c[f])
            'undefined' !== typeof a.jsonPara[f] &&
              'object' !== typeof a.config[a.jsonPara[f][0]] &&
              (a.config[a.jsonPara[f][0]] = {}),
              a.parseJSON(c[f], f);
          else if (b) {
            if (isNaN(parseInt(f)) || 500 > parseInt(f))
              a.config[a.jsonPara[b][0]][f] = c[f];
          } else
            'undefined' !== typeof a.jsonPara[f] &&
              (a.config[a.jsonPara[f][0]] = c[f]);
        }
      };
      a.getMappingParam = function (c) {
        var b = c.split(''),
          d;
        for (d = 0; d < b.length; d++)
          if (!isNaN(parseInt(b[d]))) {
            var f = d;
            break;
          }
        if (f) {
          b = c.substr(0, f);
          var e = c.substr(f, c.length - 1);
        } else b = c;
        return {
          mapping: 'undefined' !== typeof a.jsonPara[b] ? a.jsonPara[b][0] : !1,
          index: e ? e : !1,
        };
      };
    },
    K = function (a) {
      a.checkAsynchron = function (a, b, d, f) {
        if ('undefined' !== typeof l[a]) return b ? b(!0, d) : 1;
        if (0 >= f) return b ? b(!1, d) : 1;
        l.setTimeout(function () {
          d.checkAsynchron(a, b, d, f - 100);
        }, 100);
        return 1;
      };
      a.loadAsynchron = function (c, b, d, f) {
        a.include(c) && a.checkAsynchron(b, d ? d : !1, a, f ? f : 2e3);
      };
      a.include = function (a) {
        if (!document.createElement) return !1;
        var b = document.getElementsByTagName('head').item(0),
          d = document.createElement('script');
        d.setAttribute('language', 'javascript');
        d.setAttribute('type', 'text/javascript');
        d.setAttribute('src', a);
        b.appendChild(d);
        return !0;
      };
    },
    L = function (a) {
      a.userLeavesPage = !1;
      a.registerEvent = function (b, d, c) {
        b.addEventListener
          ? ('webkitvisibilitychange' === d && a.unregisterEvent(b, d, c),
            b.addEventListener(d, c, !1))
          : b.attachEvent &&
            (('beforeunload' !== d && 'webkitvisibilitychange' !== d) ||
              a.unregisterEvent(b, d, c),
            b.attachEvent('on' + d, c));
      };
      a.unregisterEvent = function (a, d, c) {
        a.removeEventListener
          ? a.removeEventListener(d, c, !1)
          : a.detachEvent && a.detachEvent('on' + d, c);
      };
      var c = function () {
        a.userLeavesPage = !0;
      };
      (function () {
        a.registerEvent(l, 'pagehide', function () {
          c();
        });
        a.registerEvent(l, 'beforeunload', function () {
          c();
        });
        a.registerEvent(l, 'unload', function () {
          c();
        });
      })();
    },
    M = function (a) {
      a.maxlen = function (a, b) {
        return a && a.length > b ? a.substring(0, b - 1) : a;
      };
      a.indexOf = function (a, b, d) {
        return a.indexOf(b, d ? d : 0);
      };
      a.wtTypeof = function (a) {
        return 'undefined' !== typeof a ? 1 : 0;
      };
      a.wtLength = function (a) {
        return 'undefined' !== typeof a ? a.length : 0;
      };
      a.wtEscape = function (a) {
        try {
          return encodeURIComponent(a);
        } catch (b) {
          return escape(a);
        }
      };
      a.wtUnescape = function (a) {
        try {
          return decodeURIComponent(a);
        } catch (b) {
          return unescape(a);
        }
      };
      a.getAttribute = function (a, b) {
        return 'string' === typeof a.getAttribute(b)
          ? a.getAttribute(b)
          : 'object' === typeof a.getAttribute(b) &&
              'object' === typeof a.attributes[b] &&
              null !== a.attributes[b]
            ? a.attributes[b].nodeValue
            : '';
      };
      a.plugInArray = function (a, b) {
        if ('object' !== typeof a) return !1;
        for (var d = 0; d < a.length; d++) {
          var c = new RegExp(a[d].toLowerCase(), 'g');
          if (-1 !== b.toLowerCase().search(c)) return a[d];
        }
        return !1;
      };
      a.getElementsBySelector = function (a, b) {
        var d = [];
        try {
          d = a.querySelectorAll(b);
        } catch (f) {}
        return d;
      };
      a.getShadowRootsBySelector = function (c) {
        var b = [];
        c = a.getElementsBySelector(l.document, c);
        for (var d = 0, f = c.length; d < f; d++) {
          var e = c[d];
          e && e.shadowRoot && b.push(e.shadowRoot);
        }
        return b;
      };
    },
    N = function (a) {
      a.decrypt = function (c) {
        var b = '';
        if (c)
          try {
            b = a.wtUnescape(c.replace(/([0-9a-fA-F][0-9a-fA-F])/g, '%$1'));
          } catch (d) {}
        return b;
      };
      a.checkSC = function (c) {
        if ('string' !== typeof a.secureConfig) return !1;
        for (var b = a.secureConfig.split(';'), d = 0; d < b.length; d++)
          if (b[d] === c) return !0;
        return !1;
      };
      a.simpleEncode = function (a, b) {
        var d = function (a) {
          return a.split('').map(function (a) {
            return a.charCodeAt(0);
          });
        };
        return b
          .split('')
          .map(d)
          .map(function (b) {
            return d(a).reduce(function (a, b) {
              return a ^ b;
            }, b);
          })
          .map(function (a) {
            return ('0' + Number(a).toString(16)).substr(-2);
          })
          .join('');
      };
    },
    O = function (a) {
      a.wtHref = function () {
        return a.wtLocation().href;
      };
      a.wtLocation = function () {
        return document.location;
      };
      a.urlParam = function (c, b, d) {
        if (!c || null === c || 'undefined' === typeof c) return d;
        var f = [];
        0 < c.indexOf('?') &&
          (f = c.split('?')[1].replace(/&amp;/g, '&').split('#')[0].split('&'));
        for (c = 0; c < f.length; c++)
          if (0 === f[c].indexOf(b + '='))
            return a.wtUnescape(
              f[c].substring(b.length + 1).replace(/\+/g, '%20'),
            );
        return d;
      };
      a.isOwnDomain = function (c) {
        if (a.domain)
          if (0 === a.domain.toUpperCase().indexOf('REGEXP:')) {
            var b = new RegExp(a.domain.substring(7), 'i');
            if (b.test(a.getDomain(c))) return !0;
          } else {
            b = a.domain.split(';');
            c = a.getDomain(c);
            for (var d = 0; d < b.length; d++) if (c === b[d]) return !0;
          }
        return !1;
      };
      a.getDomain = function (c) {
        if ('string' !== typeof c) return '';
        c = a.wtUnescape(c);
        c = c.split('://')[1];
        var b = /^(?:[^/]+:\/\/)?([^/:]+)/g;
        return 'undefined' !== typeof c && ((c = c.match(b)), c[0])
          ? c[0].toLowerCase()
          : '';
      };
    },
    A = function (a, c, b) {
      b = new RegExp(c + '=' + b);
      var d = document.location.href;
      c = new Date().getTime();
      b = b.exec(d);
      d = /wt_t=([\d]{13})/.exec(d);
      if (
        b &&
        'undefined' !== typeof b[1] &&
        d &&
        'undefined' !== typeof d[1]
      ) {
        d = parseInt(d[1]) + 9e5;
        if (!a.maxURLParameterValidity || c + a.maxURLParameterValidity < d)
          return !1;
        if (d > c) return a.wtUnescape(b[1]);
      }
      return !1;
    },
    P = function (a) {
      var c = !1;
      a.baseparams = function () {
        var b = screen.width + 'x' + screen.height + ',';
        b +=
          ('undefined' !== typeof screen.colorDepth
            ? screen.colorDepth
            : screen.pixelDepth) + ',';
        var d = navigator.cookieEnabled;
        d = 'boolean' !== typeof d ? -1 !== document.cookie.indexOf('=') : d;
        b = b + (d ? '1,' : '0,') + (new Date().getTime() + ',');
        if (a.referrerOncePerSession && a.getCookie('wt_ropc')) d = '2';
        else {
          d = '0';
          var f = A(a, 'wt_ref', '(.+?)(&|$)');
          '' !== a.getCookie('wt_ref')
            ? ((d = a.wtEscape(a.getCookie('wt_ref'))),
              a.setCookie('wt_ref', '', -3600))
            : f
              ? (d = a.wtEscape(f))
              : c
                ? ((d = a.wtEscape(c)), (c = !1))
                : 0 < document.referrer.length &&
                  (d = a.wtEscape(document.referrer));
          a.sentFullPixel ? (d = '2') : a.isOwnDomain(d) && (d = '1');
          a.referrerOncePerSession &&
            1 < d.length &&
            a.setCookie('wt_ropc', '1');
        }
        f = l.innerHeight;
        if (!f)
          try {
            f = document.documentElement.clientHeight;
          } catch (g) {}
        if (!f)
          try {
            f = document.body.clientHeight;
          } catch (g) {}
        'undefined' === typeof f && (f = -1);
        var e = l.innerWidth;
        if (!e)
          try {
            e = document.documentElement.clientWidth;
          } catch (g) {}
        if (!e)
          try {
            e = document.body.clientWidth;
          } catch (g) {}
        'undefined' === typeof e && (e = -1);
        f && f > screen.height && (f = screen.height);
        e && e > screen.width && (e = screen.width);
        return (b =
          b +
          d +
          (',' + e + 'x' + f) +
          (',' + (navigator.javaEnabled() ? '1' : '0')));
      };
      a.setReferrer = function (a) {
        'string' === typeof a && (c = a);
      };
    };
  A = function (a, c, b) {
    b = new RegExp(c + '=' + b);
    var d = document.location.href;
    c = new Date().getTime();
    b = b.exec(d);
    d = /wt_t=([\d]{13})/.exec(d);
    if (b && 'undefined' !== typeof b[1] && d && 'undefined' !== typeof d[1]) {
      d = parseInt(d[1]) + 9e5;
      if (!a.maxURLParameterValidity || c + a.maxURLParameterValidity < d)
        return !1;
      if (d > c) return a.wtUnescape(b[1]);
    }
    return !1;
  };
  var C = function (a, c, b, d) {
      '1' !== a.cookie || a.optOut || a.deactivatePixel || a.firstParty();
      (b = b ? b : '') ||
        (b = a.formObject && 'noForm' !== c ? 'form' : 'link');
      'function' === typeof a.beforeUnloadPixel
        ? a.beforeUnloadPixel()
        : 'form' === b && a.executePlugin(a.getPluginConfig('form', 'before'));
      var f = '';
      if (
        a.config.linkId &&
        (f += '&ct=' + a.wtEscape(a.maxlen(a.wtUnescape(a.config.linkId), 255)))
      ) {
        var e = a.ccParams;
        'string' === typeof e && '' !== e && (f += e);
      }
      if (a.wtEp)
        if (a.wtEpEncoded) f += a.wtEp;
        else if (((e = a.wtEp), 'string' === typeof e && '' !== e)) {
          e = e.split(/;/);
          for (var g = 0; g < e.length; g++)
            if ('undefined' !== typeof e[g]) {
              var k = e[g].split(/=/);
              a.checkSC('custom') && (k[1] = a.decrypt(k[1]));
              k[1] = a.wtEscape(k[1]);
              f += '&' + k[0] + '=' + k[1];
            }
        }
      'noForm' !== c && (f += d.getFormTrackingData());
      '' !== f &&
        (a.quicksend(
          a.wtEscape(a.contentId.split(';')[0]) + ',1,' + a.baseparams(),
          f,
        ),
        (a.config.linkId = ''),
        (a.ccParams = ''),
        (a.wtEp = ''));
      'function' === typeof a.afterUnloadPixel
        ? a.afterUnloadPixel()
        : 'form' === b && a.executePlugin(a.getPluginConfig('form', 'after'));
    },
    B = function (a) {
      var c = [],
        b;
      for (b in a.safetagParameter) {
        var d = b;
        if ('executePluginFunction' === d)
          (a.executePluginFunction += a.safetagParameter[d]),
            (a.safetagParameter[d] = '');
        else if (
          'object' !== typeof a.safetagParameter[d] ||
          a.safetagParameter[d] instanceof RegExp
        )
          (a[d] = a.safetagParameter[d]),
            ('linkTrack' !== d && 'tabBrowsing' !== d && 'execCDB' !== d) ||
              c.push(d);
        else {
          'object' !== typeof a[d] && (a[d] = {});
          for (var f in a.safetagParameter[d]) {
            var e = f;
            a[d][e] = a.safetagParameter[d][e];
          }
        }
      }
      for (b = 0; b < c.length; b++)
        switch (c[b]) {
          case 'linkTrack':
            a.linkTrackInit();
            break;
          case 'tabBrowsing':
            a.startTabBrowsing();
            break;
          case 'execCDB':
            a.startCDB();
        }
      a.safetagParameter.pixel = a;
    },
    Q = function (a) {
      var c = function () {
          if (a.isUserIdentificationOptOuted_()) a.deleteUserIdentification_();
          else if (!a.optOut && !a.deactivatePixel)
            if ('1' === a.cookie) a.firstParty();
            else {
              var b = A(a, 'wt_eid', '([\\d]{19})');
              b && (a.xwteid = b);
            }
        },
        b = function (b, d, c) {
          !1 !== b
            ? b()
            : a.executePlugin(a.getPluginConfig(d ? d : 'page', c));
        },
        d = function (a, b) {
          var d = [];
          a = a.split('&');
          for (var c = 0, f = a.length, e, k; c < f; c++) {
            e = a[c];
            k = !1;
            for (var g = 0, h = b.length, l; g < h; g++)
              if (((l = b[g]), 0 === e.indexOf(l + '='))) {
                k = !0;
                break;
              }
            k || d.push(e);
          }
          return d.join('&');
        },
        f = function (a) {
          a = a.split('&');
          for (var b = '?', d, c = a.length; c; )
            (d = parseInt(Math.random() * c)), (b += a.splice(d, 1) + '&'), c--;
          return b.substr(0, b.length - 1);
        },
        e = function () {
          for (
            var a = parseInt(10 * Math.random()) + 5, b = '', d = 0, c;
            d < a;
            d++
          )
            (c = parseInt(37 * Math.random())),
              (b += 'abcdefghijklmnopqrstuvwxyz-_0123456789'.charAt(c));
          return b;
        };
      a.getMediaCode = function () {
        if (a.mediaCode) {
          var b = [],
            d = a.mediaCode.split(';'),
            c = 0,
            f = [];
          a.mediaCodeValue && (b = a.mediaCodeValue.split(';'));
          for (var e = 0; e < d.length; e++) {
            var g = a.urlParam(location.href, d[e], '');
            if (a.mediaCodeCookie) {
              var l = !1,
                v = (a.trackId + '').split(',')[0];
              v =
                'wt_mcc_' +
                (a.config.campaignAction
                  ? a.config.campaignAction.substring(0, 1)
                  : 'c') +
                '_' +
                v;
              var t = a.getCookie(v);
              for (
                var u = d[e] + '_' + g, w = 0, x = u.length, y = 0;
                y < x;
                y++
              ) {
                var z = u.charCodeAt(y);
                w = (w << 5) - w + z;
                w &= w;
              }
              z = w > 1e15 - 1 ? '0' : w + '';
              -1 === t.indexOf(',' + z + ',') && g
                ? (f.push(d[e] + a.wtEscape('=' + g)), (l = !0))
                : c++;
              l &&
                ((g = ''),
                'eid' === a.mediaCodeCookie && (g = 2592e3),
                a.setCookie(v, t + ',' + z + ',', g));
            } else
              'undefined' !== typeof b &&
              'undefined' !== typeof b[e] &&
              '' !== b[e]
                ? f.push(d[e] + a.wtEscape('=' + b[e]))
                : '' !== g && f.push(d[e] + a.wtEscape('=' + g));
          }
          d.length === c && 0 !== d.length && f.push('ignore%3Dignore');
          a.config.campaignId = f.join(';');
        }
      };
      a.getExtLifeCycles = function (b, d, c) {
        for (var f = '', e = {}, g = b.split('|'), k = 0; k < g.length; k++) {
          for (var h = g[k].split(';'), p = 0; p < h.length; p++)
            (f = 0 === p ? f + a.wtEscape(h[p]) : f + h[p]), (f += ';');
          f = f.substr(0, f.length - 1);
          f += '|';
        }
        f = f.substr(0, f.length - 1);
        e.xlcl = a.wtEscape(b.split('|').length);
        e.xlct = a.wtEscape(d);
        'undefined' !== typeof c && (e.xlcv = a.wtEscape(c));
        e.xlc = a.wtEscape(f);
        b = '';
        for (var l in e) b += '&' + l + '=' + e[l];
        return b;
      };
      a.quicksend = function (b, c, g) {
        if (
          !a.trackDomain ||
          !a.trackId ||
          a.deactivatePixel ||
          a.deactivateRequest
        )
          a.deactivateRequest = !1;
        else {
          g || (g = 'wt' + (a.fileSuffix ? '.pl' : ''));
          a.requestObfuscation && (g += e());
          'undefined' === typeof a.requestTimeout && (a.requestTimeout = 5);
          a.cdbeid && (c = '&cdbeid=' + a.cdbeid + c);
          a.browserInformation && (c = a.browserInformation + c);
          var k = '';
          '1' === a.cookie &&
            (a.eid && (k += '&eid=' + a.eid),
            a.cookieOne && (k += '&one=1'),
            a.forceNewSession && (k += '&fns=1'));
          c = k + c;
          a.isUserIdentificationOptOuted_() && (c = '&nc=1' + c);
          (k = a.getTemporarySessionId_()) &&
            (c = '&fpt=2.0.0' + ('&fpv=' + k + c));
          k = document.location.href.split('#')[0];
          if (a.pageURLPattern && a.pageURLReplace)
            try {
              k = k.replace(a.pageURLPattern, a.pageURLReplace);
            } catch (m) {}
          c += '&pu=' + a.wtEscape(k);
          c = 'p=' + a.version + ',' + b + c;
          b = '//';
          b =
            a.sendViaServerActivated &&
            a.sendViaServerDomain &&
            a.sendViaServerPath
              ? b + (a.sendViaServerDomain + '/' + a.sendViaServerPath)
              : b + (a.trackDomain + '/' + a.trackId + '/' + g);
          0 < a.suppressIdentificationParameter.length &&
            a.isUserIdentificationOptOuted_() &&
            (c = d(c, a.suppressIdentificationParameter));
          b = a.requestObfuscation ? b + f(c) : b + ('?' + c);
          a.tabBrowsing && !a.userLeavesPage
            ? a.sendTabBrowsingPixel(b, g)
            : a.ignorePrerendering || 'undefined' === typeof document.hidden
              ? a.sendPixel(b, g)
              : ('object' !== typeof a.prerendering && (a.prerendering = []),
                !a.userLeavesPage && document.hidden
                  ? (a.prerendering.push(b),
                    a.registerEvent(document, 'visibilitychange', function () {
                      a.sendPrerendering();
                    }))
                  : a.sendPixel(b, g));
          'hm' !== g &&
            'hm.pl' !== g &&
            ((a.cookieOne = !1),
            (a.forceNewSession = !1),
            (a.sentFullPixel = 1));
        }
      };
      a.sendPrerendering = function () {
        if (!document.webkitHidden) {
          for (var b = 0; b < a.prerendering.length; b++) {
            var d = a.prerendering[b];
            d = a.replaceRequestTimestamp(d);
            d = a.replaceUserIdentification(d);
            a.sendPixel(d);
          }
          a.prerendering = [];
        }
      };
      a.send = function (b, d, c) {
        if ('link' === d || 'click' === d) a.config.linkId = b;
        a.config.contentId = a.config.contentId
          ? a.config.contentId
          : a.contentId;
        (b = b ? b : a.config.contentId) || (b = 'no_content');
        b = a.wtEscape(b) + ',1,';
        b += a.baseparams();
        var f = [];
        if (
          navigator.plugins &&
          'Microsoft Internet Explorer' !== navigator.appName
        )
          for (var e = 0, g = navigator.plugins.length; e < g; e++) {
            var k = a.plugInArray(
              a.plugins,
              'Shockwave Flash' === navigator.plugins[e].name
                ? navigator.plugins[e].description
                : navigator.plugins[e].name,
            );
            k && f.push(k);
          }
        f = f.join('|');
        e = '';
        if (a.paramFirst)
          for (g = a.paramFirst.split(';'), k = 0; k < g.length; k++) {
            var h = a.getMappingParam(g[k]),
              p = h.mapping;
            h = h.index;
            p &&
              (h
                ? a.config[p] &&
                  'undefined' !== typeof a.config[p][h] &&
                  a.config[p][h] &&
                  (e += '&' + g[k] + '=' + a.wtEscape(a.config[p][h]))
                : a.config[p] &&
                  (e += '&' + g[k] + '=' + a.wtEscape(a.config[p])));
          }
        if ('string' === typeof c && '' !== c)
          for (var u = c.split(/;/), w = 0; w < u.length; w++)
            'undefined' !== typeof u[w] &&
              ((c = u[w].split(/=/)),
              a.checkSC('custom') && (c[1] = a.decrypt(c[1])),
              (c[1] = a.wtEscape(c[1])),
              (e += '&' + c[0] + '=' + c[1]));
        else {
          a.wtEpEncoded = !1;
          var x = new a.PredefinedParameter();
          for (w in a.config) (c = w + ''), x.put(c, a.config[c]);
          h = x.get('all');
          a.config.customParameter = a.mergeCustomParameter(
            a.config.customParameter,
            h.customParameter,
          );
          w = a.checkCustomParameter(a.config.customParameter, 'cp');
          a.config.customSessionParameter = a.mergeCustomParameter(
            a.config.customSessionParameter,
            h.customSessionParameter,
          );
          c = a.checkCustomParameter(a.config.customSessionParameter, 'cs');
          g = a.checkCustomParameter(a.config.customTimeParameter, 'ce');
          k = a.checkCustomParameter(a.cdb, 'cdb');
          a.config.customEcommerceParameter = a.mergeCustomParameter(
            a.config.customEcommerceParameter,
            h.customEcommerceParameter,
          );
          p = a.checkCustomParameter(a.config.customEcommerceParameter, 'cb');
          a.config.orderValue &&
            -1 === a.paramFirst.indexOf('ov;') &&
            (e = a.checkSC('order')
              ? e + ('&ov=' + a.wtEscape(a.decrypt(a.config.orderValue)))
              : e + ('&ov=' + a.wtEscape(a.config.orderValue)));
          a.config.currency &&
            -1 === a.paramFirst.indexOf('cr;') &&
            (e = a.checkSC('order')
              ? e + ('&cr=' + a.wtEscape(a.decrypt(a.config.currency)))
              : e + ('&cr=' + a.wtEscape(a.config.currency)));
          a.config.orderId &&
            -1 === a.paramFirst.indexOf('oi;') &&
            (e += '&oi=' + a.wtEscape(a.config.orderId));
          a.config.product &&
            (-1 === a.paramFirst.indexOf('ba;') &&
              (e += '&ba=' + a.wtEscape(a.config.product)),
            a.config.productCost &&
              -1 === a.paramFirst.indexOf('co;') &&
              (e += '&co=' + a.wtEscape(a.config.productCost)),
            a.config.productQuantity &&
              -1 === a.paramFirst.indexOf('qn;') &&
              (e += '&qn=' + a.wtEscape(a.config.productQuantity)),
            (a.config.productCategory = a.mergeCustomParameter(
              a.config.productCategory,
              h.productCategory,
            )),
            (e += a.checkCustomParameter(a.config.productCategory, 'ca')),
            a.config.productStatus &&
              -1 === a.paramFirst.indexOf('st;') &&
              (e += '&st=' + a.wtEscape(a.config.productStatus)));
          var y = A(a, 'wt_cd', '(.+?)(&|$)');
          a.config.customerId || (a.config.customerId = y);
          a.config.customerId &&
            -1 === a.paramFirst.indexOf('cd;') &&
            (e += '&cd=' + a.wtEscape(a.config.customerId));
          a.config.crmCategory = a.mergeCustomParameter(
            a.config.crmCategory,
            h.crmCategory,
          );
          e += a.checkCustomParameter(a.config.crmCategory, 'vc');
          null === x.get('birthday') &&
            a.config.birthdayJ &&
            a.config.birthdayM &&
            a.config.birthdayD &&
            x.put(
              'birthday',
              a.config.birthdayJ + a.config.birthdayM + a.config.birthdayD,
            );
          null !== x.get('telefon') &&
            x.put('telefon', x.get('telefon').replace(/\W|_/g, ''));
          a.config.urmCategory = a.mergeCustomParameter(
            a.config.urmCategory,
            h.urmCategory,
          );
          e += a.checkCustomParameter(a.config.urmCategory, 'uc');
          a.config.urmCategory['701'] ||
            ((x = a.urlParam(document.location.href, 'uc701', !1)) &&
              (e += '&uc701=' + x));
          a.browserLang && (e += '&la=' + a.wtEscape(a.browserLang));
          a.config.contentGroup = a.mergeCustomParameter(
            a.config.contentGroup,
            h.contentGroup,
          );
          e += a.checkCustomParameter(a.config.contentGroup, 'cg');
          x = '';
          if (a.config.campaignId) {
            y = a.config.campaignAction
              ? a.config.campaignAction.substring(0, 1)
              : 'c';
            var z = y + '_' + a.config.campaignId;
            z in a.sentCampaignIds
              ? (a.config.campaignId = 'ignore%3Dignore')
              : (a.sentCampaignIds[z] = !0);
            'c' === y && (y = '');
            -1 === a.paramFirst.indexOf('mc;') &&
              (e += '&mc=' + a.wtEscape(a.config.campaignId));
            -1 === a.paramFirst.indexOf('mca;') && y && (e += '&mca=' + y);
          }
          a.config.customCampaignParameter = a.mergeCustomParameter(
            a.config.customCampaignParameter,
            h.customCampaignParameter,
          );
          x += a.checkCustomParameter(a.config.customCampaignParameter, 'cc');
          a.config.internalSearch &&
            -1 === a.paramFirst.indexOf('is;') &&
            (e +=
              '&is=' +
              a.wtEscape(a.maxlen(a.wtUnescape(a.config.internalSearch), 255)));
          if (a.config.dynamicParameters)
            for (u in a.config.dynamicParameters)
              (h = u + ''),
                a.config.dynamicParameters[h] &&
                  (e =
                    'object' === typeof a.config.dynamicParameters[h]
                      ? e +
                        a.checkCustomParameter(a.config.dynamicParameters, h)
                      : e +
                        ('&' +
                          u +
                          '=' +
                          a.wtEscape(a.config.dynamicParameters[h])));
          w && (e += w);
          x && (e += x);
          g && (e += g);
          p && (e += p);
          c && (e += c);
          k && (e += k);
          a.config.customEid && (e += '&ceid=' + a.config.customEid);
          a.config.xwtip && (e += '&X-WT-IP=' + a.wtEscape(a.config.xwtip));
          u =
            'string' === typeof l.webtrekkApplicationUserAgent
              ? l.webtrekkApplicationUserAgent
              : 'object' === typeof l.WebtrekkAndroidWebViewCallback &&
                  'function' ===
                    typeof l.WebtrekkAndroidWebViewCallback.getUserAgent
                ? l.WebtrekkAndroidWebViewCallback.getUserAgent()
                : '';
          if (a.config.xwtua || u)
            e +=
              '&X-WT-UA=' +
              (a.config.xwtua ? a.wtEscape(a.config.xwtua) : a.wtEscape(u));
          a.config.xwtrq && (e += '&X-WT-RQ=' + a.wtEscape(a.config.xwtrq));
          a.xwteid &&
            ((e += '&X-WT-EID=' + a.wtEscape(a.xwteid)), (a.xwteid = !1));
          a.config.xwtstt && (e += '&X-WT-STT=' + a.wtEscape(a.config.xwtstt));
        }
        a.config.linkId &&
          a.config.customClickParameter &&
          ((e += a.checkCustomParameter(
            a.config.customClickParameter[a.config.linkId]
              ? a.config.customClickParameter[a.config.linkId]
              : a.config.customClickParameter,
            'ck',
          )),
          (a.ccParams = !1));
        a.config.xlc &&
          a.config.xlct &&
          ('' !== a.config.xlc || '' !== a.config.xlct) &&
          ((u = a.config.xlcv
            ? a.getExtLifeCycles(a.config.xlc, a.config.xlct, a.config.xlcv)
            : a.getExtLifeCycles(a.config.xlc, a.config.xlct)),
          (e += u));
        a.config.contentId ||
          a.config.linkId ||
          ((a.config.contentId = a.contentId), (a.config.linkId = 'wt_ignore'));
        a.config.linkId
          ? ((a.wtEp = e), (a.wtEpEncoded = !0), C(a, 'noForm', d))
          : ('1' === a.cookie
              ? a.cookieOne && (e += '&np=' + a.wtEscape(f))
              : (e += '&np=' + a.wtEscape(f)),
            a.quicksend(b, e));
      };
      var g = function () {
        a.safetagTimeoutStarted = !0;
        var b = new Date().getTime() - a.startSafetagTimeoutDate;
        if (a.safetagInProgress && b < a.safetag.timeout)
          l.setTimeout(function () {
            g();
          }, 5);
        else {
          a.safetagTimeoutStarted = !1;
          a.safetagInProgress = !1;
          b > a.safetag.timeout && (a.xwtstt = a.safetag.timeout + '');
          for (b = 0; b < a.saveSendinfoArguments.length; b++) {
            var d = a.saveSendinfoArguments[b];
            a.sendinfo(d[0], d[1], d[2], d[3]);
          }
          a.saveSendinfoArguments = [];
        }
      };
      a.sendinfo = function (d, e, f, n) {
        f = f ? f : 'page';
        -1 === location.href.indexOf('fb_xd_fragment') &&
          (a.safetag && B(a),
          (a.config = 'object' === typeof d ? d : a.getConfig()),
          a.safetagInProgress
            ? (d
                ? a.saveSendinfoArguments.push([a.config, e, f, n])
                : a.saveSendinfoArguments.push([!1, e, f, n]),
              a.safetagTimeoutStarted ||
                ((a.startSafetagTimeoutDate = new Date().getTime()),
                l.setTimeout(function () {
                  g();
                }, 5)))
            : (a.config.campaignId ||
                !a.mediaCode ||
                'page' !== f ||
                a.config.linkId ||
                a.getMediaCode(),
              a.config.linkId && ((f = 'click'), e || (e = a.config.linkId)),
              c(),
              b(a.beforeSendinfoPixel, f, 'before'),
              a.safetag && B(a),
              ('' === a.contentId && '' === e) || a.send(e, f, n),
              b(a.afterSendinfoPixel, f, 'after')));
      };
    },
    R = function (a) {
      for (var c = [J, K, L, M, N, O, P, Q], b = 0; b < c.length; b++) c[b](a);
    },
    S = function (a) {
      a.setProperty('paramFirst', '');
      a.jsonPara = {
        ck: ['customClickParameter', {}],
        cp: ['customParameter', {}],
        cs: ['customSessionParameter', {}],
        ce: ['customTimeParameter', {}],
        cb: ['customEcommerceParameter', {}],
        vc: ['crmCategory', {}],
        uc: ['urmCategory', {}],
        ca: ['productCategory', {}],
        cc: ['customCampaignParameter', {}],
        cg: ['contentGroup', {}],
        ct: ['linkId', ''],
        ov: ['orderValue', ''],
        cr: ['currency', ''],
        oi: ['orderId', ''],
        ba: ['product', ''],
        co: ['productCost', ''],
        qn: ['productQuantity', ''],
        st: ['productStatus', ''],
        cd: ['customerId', ''],
        is: ['internalSearch', ''],
        mc: ['campaignId', ''],
        mca: ['campaignAction', ''],
      };
      a.checkBrowser = function () {
        a.isIE = -1 !== navigator.appName.indexOf('Microsoft');
        a.isIE ||
          ((a.isOpera = -1 !== navigator.appName.indexOf('Opera')),
          a.isOpera ||
            ((a.isSafari =
              -1 !== navigator.vendor.toLowerCase().indexOf('apple')),
            (a.isChrome =
              -1 !== navigator.vendor.toLowerCase().indexOf('google')),
            a.isSafari ||
              a.isChrome ||
              (a.isFirefox =
                -1 !== navigator.userAgent.toLowerCase().indexOf('firefox'))));
      };
      a.generateDefaultConfig(
        'trackId trackDomain domain secureConfig beforeSendinfoPixel afterSendinfoPixel beforeUnloadPixel afterUnloadPixel ignorePrerendering plugins trackingSwitchMediaCode trackingSwitchMediaCodeValue trackingSwitchMediaCodeTimestamp isIE isOpera isSafari isChrome isFirefox wtEpEncoded fileSuffix dynamicParameters xwtip xwtua xwtrq config xwteid xwtstt customTimeParameter sentFullPixel wtEp pageURLPattern pageURLReplace browserInformation'.split(
          ' ',
        ),
      );
      a.plugins ||
        (a.plugins =
          'Adobe Acrobat;Windows Media Player;Shockwave Flash;RealPlayer;QuickTime;Java;Silverlight'.split(
            ';',
          ));
      'string' === typeof a.plugins && (a.plugins = a.plugins.split(';'));
      a.browserLang = !1;
      'string' === typeof navigator.language
        ? (a.browserLang = navigator.language.substring(0, 2))
        : 'string' === typeof navigator.userLanguage &&
          (a.browserLang = navigator.userLanguage.substring(0, 2));
      a.checkBrowser();
    },
    T = function (a) {
      a.url2contentId = function (c) {
        if (!c) return 'no_content';
        if (a.pageURLPattern && a.pageURLReplace)
          try {
            c = c.replace(a.pageURLPattern, a.pageURLReplace);
          } catch (b) {}
        c = /\/\/(.*)/.exec(c);
        return 1 > c.length
          ? 'no_content'
          : c[1]
              .split('?')[0]
              .split('#')[0]
              .replace(/\./g, '_')
              .replace(/\//g, '.')
              .replace(/\.{2,}/g, '.')
              .toLowerCase()
              .split(';')[0];
      };
      a.generateDefaultConfig(
        'contentId contentGroup internalSearch numberSearchResults errorMessages npsScore npsScoreFeedback paywall articleTitle pageMainCategory pageSubCategory pageAuthor contentTags pageTitle pageType pageLength daysSincePublication testVariant testExperiment customParameter'.split(
          ' ',
        ),
      );
      a.contentId = a.contentId
        ? a.contentId
        : a.url2contentId(document.location.href);
    },
    U = function (a) {
      'undefined' === typeof a.safetag && (a.safetag = !1);
      'undefined' === typeof a.safetagInProgress && (a.safetagInProgress = !1);
      'undefined' === typeof a.safetagParameter && (a.safetagParameter = {});
      'undefined' === typeof a.update && (a.update = function () {});
      a.saveSendinfoArguments = [];
      a.safetagTimeoutStarted = !1;
    },
    V = function (a) {
      a.generateDefaultConfig([
        'loginStatus',
        'pixelVersion',
        'trackingPlatform',
        'customSessionParameter',
        'forceNewSession',
      ]);
    },
    W = function (a) {
      a.generateDefaultConfig(
        'customEcommerceParameter orderValue currency orderId product productCost productQuantity productCategory productStatus couponValue productLabel productMainCategory productSubCategory productManufacturer paymentMethod productShortDescription productLongDescription shippingService shippingSpeed shippingCosts grossMargin orderStatus productVariant productSoldOut'.split(
          ' ',
        ),
      );
    },
    X = function (a) {
      a.generateDefaultConfig(
        'crmCategory urmCategory customerId customEid xlc xlct xlcv paywallUser email emailRID emailOptin firstName lastName telefon gender birthday birthdayJ birthdayM birthdayD country city postalCode street streetNumber validation'.split(
          ' ',
        ),
      );
    },
    Y = function (a) {
      a.setProperty('formAttribute', 'name');
      a.setProperty('formFieldAttribute', 'name');
      a.setProperty('formValueAttribute', 'value');
      a.setProperty('formFieldDefaultValue', {});
      a.setProperty('multipleFormArray', []);
      a.generateDefaultConfig(
        'form formFullContent formAnonymous gatherFormsP formObject formName formFocus formSubmit formPathAnalysis'.split(
          ' ',
        ),
      );
    },
    Z = function (a) {
      a.setProperty('linkTrackAttribute', 'name');
      a.setProperty('delayLinkTrackTime', 200);
      a.setProperty('linkTrackShadowRoot', []);
      a.generateDefaultConfig(
        'linkId linkTrack linkTrackParams linkTrackPattern linkTrackReplace linkTrackDownloads linkTrackIgnorePattern customClickParameter delayLinkTrack noDelayLinkTrackAttribute linktrackNamedlinksOnly ccParams'.split(
          ' ',
        ),
      );
    },
    aa = function (a) {
      a.sentCampaignIds = {};
      a.setProperty('campaignAction', 'click');
      a.generateDefaultConfig(
        'mediaCode mediaCodeValue mediaCodeCookie campaignId customCampaignParameter referrerOncePerSession'.split(
          ' ',
        ),
      );
    },
    ba = function (a) {
      a.cdb = {};
      a.cdbData = [];
    },
    ca = function (a, c, b) {
      a.getConfig = function (b) {
        var d = {},
          c;
        for (c in a) d[c] = b ? !1 : a[c];
        return d;
      };
      a.setProperty = function (d, f) {
        a[d] = f;
        'undefined' !== typeof c[d]
          ? (a[d] = c[d])
          : 'undefined' !== typeof b[d] && (a[d] = b[d]);
      };
      a.generateDefaultConfig = function (b) {
        for (var d = 0; d < b.length; d++) a.setProperty(b[d], !1);
      };
      (function () {
        for (var d = [S, T, U, V, W, X, Y, Z, aa, ba], f = 0; f < d.length; f++)
          d[f](a, c, b);
      })();
    };
  B = function (a) {
    var c = [],
      b;
    for (b in a.safetagParameter) {
      var d = b;
      if ('executePluginFunction' === d)
        (a.executePluginFunction += a.safetagParameter[d]),
          (a.safetagParameter[d] = '');
      else if (
        'object' !== typeof a.safetagParameter[d] ||
        a.safetagParameter[d] instanceof RegExp
      )
        (a[d] = a.safetagParameter[d]),
          ('linkTrack' !== d && 'tabBrowsing' !== d && 'execCDB' !== d) ||
            c.push(d);
      else {
        'object' !== typeof a[d] && (a[d] = {});
        for (var f in a.safetagParameter[d]) {
          var e = f;
          a[d][e] = a.safetagParameter[d][e];
        }
      }
    }
    for (b = 0; b < c.length; b++)
      switch (c[b]) {
        case 'linkTrack':
          a.linkTrackInit();
          break;
        case 'tabBrowsing':
          a.startTabBrowsing();
          break;
        case 'execCDB':
          a.startCDB();
      }
    a.safetagParameter.pixel = a;
  };
  var da = function (a) {
      a.pageCounter = 0;
      a.clickCounter = 0;
      a.linkCounter = 0;
      a.formCounter = 0;
      a.configCounter = 0;
      a.mediaCounter = 0;
      a.plugin = {};
      a.setProperty('executePluginFunction', '');
      a.getRequestCounter = function (c, b) {
        var d = 0;
        'after' !== b && d++;
        return 'undefined' !== typeof a[c + 'Counter']
          ? ((a[c + 'Counter'] += d), a[c + 'Counter'])
          : 0;
      };
      a.getPluginConfig = function (c, b) {
        return {
          instance: a,
          mode: c,
          type: b,
          requestCounter: a.getRequestCounter(c, b),
        };
      };
      a.executePlugin = function (c, b) {
        if (
          !a.executePluginFunction ||
          'string' !== typeof a.executePluginFunction
        )
          return !1;
        b = b ? b : {};
        a.epf = !1;
        for (
          var d = a.executePluginFunction.split(';'), f = 0;
          f < d.length;
          f++
        )
          if (d[f] && 'function' === typeof l[d[f]]) {
            a.epf = l[d[f]];
            try {
              a.epf(c, b);
            } catch (e) {}
          }
        return !1 !== a.epf;
      };
      a.triggerConfigPlugins = function (c) {
        'undefined' !== typeof a.safetag && a.safetag && B(a);
        a.config = 'object' === typeof c ? c : a.getConfig();
        a.executePlugin(a.getPluginConfig('config', 'before'));
        'undefined' !== typeof a.safetag && a.safetag && B(a);
        a.executePlugin(a.getPluginConfig('config', 'after'));
      };
    },
    ea = function (a) {
      a.setProperty('cookie', '3');
      a.setProperty('updateCookie', !0);
      a.setProperty('cookieSecure', !1);
      a.setProperty('cookieEidTimeout', !1);
      a.setProperty('cookieSidTimeout', !1);
      var c = function (b, d, c, e, g) {
        b = a.wtEscape(b) + '=' + a.wtEscape(d);
        b = b + (';Domain=' + c) + ';Path=/';
        e && (b += ';Expires=' + a.getExpiryDate(e, g));
        b += ';SameSite=Lax';
        a.cookieSecure && (b += ';Secure');
        document.cookie = b;
      };
      a.getExpiryDate = function (a, d) {
        var b = new Date(),
          c = b.getTime();
        d && (c = parseInt(d));
        b.setTime(c + 6e4 * a);
        return b.toUTCString();
      };
      a.setCookie = function (b, d, f, e) {
        var g = document.location.hostname;
        if (-1 === g.search(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/))
          for (
            var k = g.split('.'), h = k[k.length - 1], p = k.length - 2;
            0 <= p;
            p--
          )
            if (((h = k[p] + '.' + h), c(b, d, h, f, e), a.getCookie(b) === d))
              return;
        c(b, d, g, f, e);
      };
      a.getCookie = function (b) {
        for (var d = document.cookie.split(';'), c = 0; c < d.length; c++) {
          var e = d[c].substr(0, d[c].indexOf('=')),
            g = d[c].substr(d[c].indexOf('=') + 1);
          e = e.replace(/^\s+|\s+$/g, '');
          if (e === b) return a.wtUnescape(g);
        }
        return '';
      };
    },
    fa = function (a) {
      a.cookieManager = function (a, b, d, f) {
        this.name = a;
        this.keySeperator = '~';
        this.fieldSeparator = '#';
        this.durationSeperator = '|';
        this.found = !1;
        this.expires = b ? b : !1;
        this.accessPath = d ? d : '/';
        this.secure = f ? f : !1;
        this.rawValue = '';
        this.fields = [];
        this.fieldsDuration = [];
        var c = function (a) {
            try {
              return decodeURIComponent(a);
            } catch (h) {
              return l.unescape(a);
            }
          },
          g = function (a) {
            try {
              return encodeURIComponent(a);
            } catch (h) {
              return l.escape(a);
            }
          };
        this.read = function () {
          this.rawValue = null;
          this.found = !1;
          for (var a = document.cookie.split(';'), b = 0; b < a.length; b++) {
            var d = a[b].substr(0, a[b].indexOf('=')),
              e = a[b].substr(a[b].indexOf('=') + 1);
            d = d.replace(/^\s+|\s+$/g, '');
            d === this.name && ((this.rawValue = e), (this.found = !0));
          }
          if (null !== this.rawValue) {
            b = 0;
            do
              (a = this.rawValue.indexOf(this.fieldSeparator, b)),
                -1 !== a &&
                  ((b = this.rawValue
                    .substring(b, a)
                    .split(this.durationSeperator)),
                  (d = b[0].split(this.keySeperator)),
                  (this.fields[d[0]] = c(d[1])),
                  (this.fieldsDuration[d[0]] = parseInt(c(b[1]))),
                  (b = a + 1));
            while (-1 !== a && a !== this.rawValue.length - 1);
          }
          return this.found;
        };
        this.getSize = function () {
          var a = new Date().getTime(),
            b = '',
            d;
          for (d in this.fields) {
            var c = d + '';
            this.fieldsDuration[c] >= a &&
              (b +=
                g(c) +
                this.keySeperator +
                g(this.fields[c]) +
                this.durationSeperator +
                g(this.fieldsDuration[c]) +
                this.fieldSeparator);
          }
          return b.length;
        };
        this.write = function () {
          var a = new Date().getTime(),
            b = !0,
            d = this.name + '=',
            c;
          for (c in this.fields) {
            var e = c + '';
            this.fieldsDuration[e] >= a &&
              ((d +=
                g(e) +
                this.keySeperator +
                g(this.fields[e]) +
                this.durationSeperator +
                g(this.fieldsDuration[e]) +
                this.fieldSeparator),
              (b = !1));
          }
          a = b ? -99999 : this.expires;
          '' !== a &&
            'number' === typeof a &&
            ((b = new Date()),
            b.setTime(new Date().getTime() + 864e5 * a),
            (d += '; expires=' + b.toGMTString()));
          null !== this.accessPath && (d += '; PATH=' + this.accessPath);
          a = location.hostname;
          -1 === a.search(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) &&
            ((a = location.hostname.split('.')),
            (a = a[a.length - 2] + '.' + a[a.length - 1]));
          b = '';
          this.secure && (b = ';secure');
          document.cookie = d + ('; DOMAIN=' + a) + b;
        };
        this.remove = function () {
          this.expires = -10;
          this.write();
          return this.read();
        };
        this.get = function (a) {
          var b = new Date().getTime();
          return this.fieldsDuration[a] >= b ? this.fields[a] : '';
        };
        this.set = function (a, b, d, c, e) {
          d = d ? d : 31536e3;
          c = c ? c : 'last';
          var f = new Date().getTime();
          if (
            'first' === c &&
            '' !== this.fields[a] &&
            null !== this.fields[a] &&
            this.fieldsDuration[a] >= f
          )
            return this.fields[a];
          this.fields[a] = b;
          this.fieldsDuration[a] = f + 1e3 * parseInt(d);
          e || this.write();
          return b;
        };
        this.prepare = function (a, b, d, c) {
          return this.set(a, b, d, c, !0);
        };
        this.read();
      };
    },
    ha = function (a, c, b) {
      ea(a, c, b);
      fa(a);
    },
    ia = function (a) {
      a.optOut = !1;
      a.setProperty('optoutName', 'webtrekkOptOut');
      a.optOut = '' !== a.getCookie(a.optoutName);
      a.optOut && (a.deactivatePixel = !0);
      a.getTrackingOptOut = function () {
        return !!a.getCookie(a.optoutName);
      };
      a.setTrackingOptOut = function (c, b) {
        c = 'number' === typeof c ? c : 2592e3;
        b = 'function' === typeof b ? b : function () {};
        a.setCookie(a.optoutName, '1', c);
        a.trackId && a.trackDomain
          ? a.invokeImage(
              'https://' +
                a.trackDomain +
                '/' +
                a.trackId +
                '/optout?duration=' +
                parseInt(c / 1440 + ''),
              b,
            )
          : b();
      };
      a.removeTrackingOptOut = function () {
        a.setTrackingOptOut(-3600);
      };
    },
    D = {
      data_: {},
      setItem: function (a, c) {
        this.data_[a] = c + '';
      },
      getItem: function (a) {
        return 'undefined' !== typeof this.data_[a] ? this.data_[a] : null;
      },
      removeItem: function (a) {
        delete this.data_[a];
      },
      clear: function () {
        this.data_ = {};
      },
    },
    E = function () {
      try {
        l.localStorage.setItem('wt_test', '1');
        l.localStorage.removeItem('wt_test');
        var a = l.localStorage;
      } catch (c) {
        a = D;
      }
      return a;
    },
    F = function (a) {
      var c = E();
      this.setItem_ = function (b) {
        c.setItem(a, b);
      };
      this.removeItem_ = function () {
        c.removeItem(a);
      };
      this.getItem_ = function () {
        var b = c.getItem(a);
        return 'string' === typeof b && b ? b : '';
      };
      this.clear_ = function () {
        c.clear();
      };
    },
    ja = function (a) {
      var c = function () {
        a.enableIdentificationOptOut &&
          (a.enableAnonymousFunction = a.enableIdentificationOptOut);
        'miCookieOptOut' !== a.optOutIdentificationName &&
          (a.anonymousCookieName = a.optOutIdentificationName);
      };
      a.setProperty('enableIdentificationOptOut', !1);
      a.setProperty('enableAnonymousFunction', !1);
      a.setProperty('anonymousOptIn', !1);
      a.setProperty('optOutIdentificationName', 'miCookieOptOut');
      a.setProperty('anonymousCookieName', 'miCookieOptOut');
      a.setProperty('suppressIdentificationParameter', []);
      a.setProperty('temporarySessionId', '');
      a.setProperty('saveTemporarySessionId', !1);
      a.getIdentifierOptOut = function () {
        c();
        return !!a.getCookie(a.anonymousCookieName);
      };
      a.setIdentifierOptOut = function (b, d) {
        c();
        d = 'function' === typeof d ? d : function () {};
        a.setCookie(
          a.anonymousCookieName,
          '1',
          'number' === typeof b ? b : 2592e3,
        );
        d();
      };
      a.removeIdentifierOptOut = function () {
        c();
        a.setIdentifierOptOut(-3600);
      };
      a.getAnonymousCookie = a.getIdentifierOptOut;
      a.setAnonymousCookie = a.setIdentifierOptOut;
      a.removeAnonymousCookie = a.removeIdentifierOptOut;
      a.isUserIdentificationOptOuted_ = function () {
        c();
        var b = !!a.getAnonymousCookie();
        return (
          a.enableAnonymousFunction &&
          ((!a.anonymousOptIn && b) || (a.anonymousOptIn && !b))
        );
      };
      a.getTemporarySessionId_ = function () {
        var b = a.saveTemporarySessionId,
          d = a.temporarySessionId,
          c = new F('wt_tsid');
        d && b ? c.setItem_(d) : b && (d = c.getItem_());
        return d;
      };
      a.deleteUserIdentification_ = function () {
        a.eid = !1;
        a.firstVisitContact = !1;
        a.firstVisitTimestamp = !1;
        a.lastVisitContact = !1;
        a.cookieOne = !1;
        a.forceNewSession = !1;
        a.setCookie('wt3_eid', '', -3600);
        a.setCookie('wt3_sid', '', -3600);
        a.setCookie('wt_cdbeid', '', -3600);
      };
    },
    ka = function (a) {
      a.setProperty('pixelSampling', !1);
      a.setPixelSampling = function (c) {
        c = c ? c : a.pixelSampling;
        for (
          var b = a.trackId.split(',')[0],
            d = a.getCookie('wt3_sample').split(';'),
            f = !1,
            e = 0;
          e < d.length;
          e++
        )
          -1 !== d[e].indexOf(b + '|' + c)
            ? (f = !0)
            : -1 !== d[e].indexOf(b + '|') && (d[e] = '');
        e = 6;
        a.cookieEidTimeout && (e = a.cookieEidTimeout);
        f
          ? ((d = d.join(';')), a.setCookie('wt3_sample', d, 43200 * e))
          : (Math && Math.random && 0 === parseInt(Math.random() * c)
              ? d.push(b + '|' + c + '|1')
              : d.push(b + '|' + c + '|0'),
            a.setCookie('wt3_sample', d.join(';'), 43200 * e),
            (d = a.getCookie('wt3_sample')));
        -1 === d.indexOf(b + '|' + c + '|1') && (a.deactivatePixel = !0);
      };
      a.pixelSampling && !a.optOut && a.setPixelSampling();
    },
    la = function (a, c, b) {
      a.deactivatePixel = !1;
      ia(a);
      ka(a);
      ja(a);
    };
  D = {
    data_: {},
    setItem: function (a, c) {
      this.data_[a] = c + '';
    },
    getItem: function (a) {
      return 'undefined' !== typeof this.data_[a] ? this.data_[a] : null;
    },
    removeItem: function (a) {
      delete this.data_[a];
    },
    clear: function () {
      this.data_ = {};
    },
  };
  E = function () {
    try {
      l.localStorage.setItem('wt_test', '1');
      l.localStorage.removeItem('wt_test');
      var a = l.localStorage;
    } catch (c) {
      a = D;
    }
    return a;
  };
  F = function (a) {
    var c = E();
    this.setItem_ = function (b) {
      c.setItem(a, b);
    };
    this.removeItem_ = function () {
      c.removeItem(a);
    };
    this.getItem_ = function () {
      var b = c.getItem(a);
      return 'string' === typeof b && b ? b : '';
    };
    this.clear_ = function () {
      c.clear();
    };
  };
  var ma = function (a, c) {
      var b = this,
        d = new F(a),
        f = [];
      b.MAX_QUEUEING_ITEMS = c;
      var e = function () {
        for (; f.length > b.MAX_QUEUEING_ITEMS; ) b.shift_();
        d.setItem_(f.join('|'));
      };
      f = (function () {
        var a = d.getItem_(),
          b = [];
        a && 'string' === typeof a && (b = a.split('|'));
        return b;
      })();
      b.length_ = function () {
        return f.length;
      };
      b.push_ = function (a) {
        f.push(a);
        e();
      };
      b.first_ = function () {
        return 0 === f.length ? '' : f[0];
      };
      b.shift_ = function () {
        var a = f.shift();
        e();
        return 'string' === typeof a ? a : '';
      };
      b.clear_ = function () {
        f = [];
        d.removeItem_();
      };
    },
    na = function (a, c, b) {
      var d = c.resendInterval,
        f = c.ttl,
        e = c.retries,
        g = c.retriesOption,
        k = 'wt_brq_' + a,
        h = this,
        p = !1,
        n = !1,
        m = !1,
        r = null,
        q = 0;
      h.queue_ = new ma(a, c.size);
      var v = function (a) {
          a = b.urlParam(a, 'p', '').replace(/[\s\S]+,(\d{13}),.+/, '$1');
          return 'string' === typeof a &&
            a &&
            ((a = parseInt(a)), !isNaN(a) && Date.now() <= a + f)
            ? !1
            : !0;
        },
        t = function () {
          if (!p)
            if (0 >= h.queue_.length_()) n = !1;
            else {
              var a = h.queue_.first_();
              v(a)
                ? (h.queue_.shift_(), t())
                : b.invokeImage(
                    a,
                    function (a, c, f) {
                      b._requestLoadHandler(a, c, f);
                      if ('success' === c)
                        return h.queue_.shift_(), (q = 0), t();
                      q++;
                      return -1 < e && q >= e
                        ? (h.queue_.shift_(),
                          2 === g &&
                            ((m = !0), h.queue_.clear_(), b.setCookie(k, '1')),
                          t())
                        : (r = l.setTimeout(function () {
                            t();
                          }, d));
                    },
                    6e4,
                  );
            }
        },
        u = function () {
          '1' === b.getCookie(k)
            ? (m = !0)
            : !n && 0 < h.queue_.length_() && ((n = !0), t());
        };
      u();
      h.add_ = function (a) {
        m || (h.queue_.push_(a), u());
      };
      h.remove_ = function () {
        l.clearTimeout(r);
        h.queue_.clear_();
        n = !1;
      };
      h.destroy_ = function () {
        l.clearTimeout(r);
        p = !0;
      };
    },
    oa = function (a) {
      var c = !1,
        b,
        d = function () {
          b =
            'object' === typeof l.WebtrekkAndroidWebViewCallback
              ? l.WebtrekkAndroidWebViewCallback
              : {};
          c = 'function' === typeof b.trackCustomPage;
        };
      d();
      this.isActive_ = function () {
        d();
        return c;
      };
      this.add_ = function (d) {
        if (c) {
          var e = d.split('?')[1].split('&');
          d = {};
          for (var f = 0, k = e.length; f < k; f++) {
            var h = e[f].split('=');
            d[a.wtUnescape(h[0])] = a.wtUnescape(h[1]);
          }
          delete d.eid;
          delete d.fns;
          delete d.one;
          delete d.la;
          delete d['X-WT-UA'];
          e = d.p.split(',');
          e.splice(-8);
          e.shift();
          e = e.join(',');
          delete d.p;
          b.trackCustomPage(e, l.JSON.stringify(d));
        }
      };
    },
    pa = function (a) {
      a.deactivateRequest = !1;
      a.completeRequest = !1;
      a.requestQueue = {};
      a.webtrekkSDKCallback = null;
      a.setProperty('simulatedRequestTimeout', 500);
      a.setProperty('replaceMutatedVowel', !1);
      a.setProperty('requestLimitActivated', !0);
      a.setProperty('requestLimitAmount', 1e3);
      a.setProperty('requestLimitTime', 1800);
      a.setProperty('maxRequestLength', 24576);
      a.setProperty('requestObfuscation', !1);
      a.setProperty('requestQueueActivated', !1);
      a.setProperty('requestQueueTTL', 3e5);
      a.setProperty('requestQueueResendInterval', 5e3);
      a.setProperty('requestQueueSize', 100);
      a.setProperty('requestQueueRetries', -1);
      a.setProperty('requestQueueRetriesOption', 1);
      a.setProperty('sendViaSDK', !1);
      a.setProperty('sendViaServerActivated', !1);
      a.setProperty('sendViaServerDomain', '');
      a.setProperty('sendViaServerPath', '');
      a.setProperty('sendViaServerDroppedRequests', 0);
      a.setProperty('sendViaServerBlacklist', [/.+/]);
      var c = !1,
        b = function (a) {
          return -1 !== a.indexOf('ct=')
            ? 'link'
            : -1 !== a.indexOf('fn=')
              ? 'form'
              : -1 !== a.indexOf('mi=')
                ? 'media'
                : -1 !== a.indexOf('/cdb') || -1 !== a.indexOf('/fbc')
                  ? 'cdb'
                  : -1 !== a.indexOf('/ce')
                    ? 'independent'
                    : -1 !== a.indexOf('/re')
                      ? 'redirect'
                      : 'page';
        },
        d = function (a, b, d) {
          'function' !== typeof l.Image &&
            (l.Image = function () {
              return document.createElement('img');
            });
          var c = new l.Image();
          (function (a, c) {
            var e = !1,
              f = function (d) {
                return e ? !1 : ((e = !0), b(a, d, Date.now() - c));
              };
            a.onerror = function () {
              f('error');
            };
            a.onload = function () {
              f('success');
            };
            l.setTimeout(function () {
              f('timeout');
            }, d);
          })(c, Date.now());
          c.src = a;
        };
      a._requestLoadHandler = function (d, c, g) {
        if (d && c) {
          var e = b(d.src);
          a.executePlugin(
            { instance: a, mode: e, type: c, requestCounter: 0 },
            { status: c, time: g, request: d.src, item: d },
          );
        }
      };
      a.invokeImage = function (a, b, c) {
        a &&
          'string' === typeof a &&
          d(
            a,
            'function' === typeof b ? b : function () {},
            'number' === typeof c ? c : 2e3,
          );
      };
      a.sendPixel = function (d, e) {
        var f = '';
        var k = 0;
        a.cookieSecure && (k += 1);
        a.requestObfuscation && (k += 2);
        a.sendViaSDK && (k += 4);
        a.sendViaServerActivated && (k += 8);
        a.requestQueueActivated && (k += 16);
        a.requestLimitActivated && (k += 32);
        a.enableAnonymousFunction && (k += 64);
        k && (f += '&pf=' + k);
        k = a._gps();
        k.id_ && ((f += '&cs802=' + k.id_), (f += '&cs801=' + k.version_));
        f = d + f;
        k = b(f);
        var h = a.sendViaServerBlacklist;
        for (var l = [], n = 0; n < h.length; n++)
          if ('string' === typeof h[n]) {
            if (-1 !== h[n].indexOf('*'))
              try {
                h[n] = new RegExp(
                  h[n].replace(/(\.)/g, '\\$1').replace(/\*/g, '.*'),
                );
              } catch (u) {}
            l.push(h[n]);
          } else h[n] instanceof RegExp && l.push(h[n]);
        0 === l.length && (l = [/.+/]);
        h = l;
        if (
          a.sendViaServerActivated &&
          0 !== a.sendViaServerDroppedRequests &&
          ((1 === a.sendViaServerDroppedRequests &&
            -1 !== f.search(/[?&]ov=.+/)) ||
            (2 === a.sendViaServerDroppedRequests &&
              -1 !== f.search(/[?&]st=(view|add|conf)/)) ||
            (3 === a.sendViaServerDroppedRequests && 'page' === k))
        ) {
          l = '';
          try {
            var m = d.split('?')[1].split('&');
            d = {};
            n = 0;
            for (var r = m.length; n < r; n++) {
              var q = m[n].split('=');
              d[a.wtUnescape(q[0])] = a.wtUnescape(q[1]);
            }
            var v = d.p.split(',');
            v.splice(-8);
            v.shift();
            l = v.join(',');
          } catch (u) {}
          m = l;
          r = !1;
          for (q = 0; q < h.length; q++)
            if ('string' === typeof h[q]) {
              if (h[q] === m) {
                r = !0;
                break;
              }
            } else if (h[q].test(m)) {
              r = !0;
              break;
            }
          if (r) return;
        }
        a: {
          if (a.requestLimitActivated) {
            r = a.trackId.split(',')[0];
            q = a.getCookie('wt_rla').split(';');
            m = {};
            v = 0;
            for (d = q.length; v < d; v++)
              (h = q[v].split(',')),
                3 <= h.length &&
                  ((l = parseInt(h[1])),
                  (n = parseInt(h[2])),
                  (m[h[0]] = {
                    amount: isNaN(l) ? 0 : l,
                    time: isNaN(n) ? new Date().getTime() : n,
                  }));
            'undefined' === typeof m[r] &&
              (m[r] = { amount: 0, time: new Date().getTime() });
            q = new Date().getTime();
            if (q - m[r].time > 1e3 * a.requestLimitTime)
              (c = !1), (m[r] = { amount: 0, time: q });
            else if (
              (m[r].amount === a.requestLimitAmount - 1 && (c = !0),
              m[r].amount >= a.requestLimitAmount)
            ) {
              var t = !0;
              break a;
            }
            if ('link' === k || 'page' === k || 'form' === k) {
              m[r].amount++;
              k = [];
              for (t in m) k.push(t + ',' + m[t].amount + ',' + m[t].time);
              a.setCookie('wt_rla', k.join(';'));
            }
          }
          t = !1;
        }
        if (!t) {
          if (a.replaceMutatedVowel) {
            t = [
              [/%C3%84/g, 'ae'],
              [/%C3%A4/g, 'ae'],
              [/%C4/g, 'ae'],
              [/%E4/g, 'ae'],
              [/%C3%96/g, 'oe'],
              [/%C3%B6/g, 'oe'],
              [/%D6/g, 'oe'],
              [/%F6/g, 'oe'],
              [/%C3%9C/g, 'ue'],
              [/%C3%BC/g, 'ue'],
              [/%DC/g, 'ue'],
              [/%FC/g, 'ue'],
              [/%C3%9F/g, 'ss'],
              [/%DF/g, 'ss'],
            ];
            k = 0;
            for (m = t.length; k < m; k++) f = f.replace(t[k][0], t[k][1]);
            f = f.toLowerCase();
          }
          a.completeRequest = f.split('?')[1];
          f = a.maxlen(f, a.maxRequestLength);
          c &&
            (f += '&rla=' + a.requestLimitAmount + '%7C' + a.requestLimitTime);
          a.sendPixelImage(f, e);
        }
      };
      a.sendPixelImage = function (b, d) {
        0 !== b.search(/https:|http:/) && (b = 'https:' + b);
        if ('hm' === d || 'hm.pl' === d) b += '&hm_ts=' + new Date().getTime();
        a.sendViaSDK &&
          null === a.webtrekkSDKCallback &&
          (a.webtrekkSDKCallback = new oa(a));
        'hm' !== d &&
        'hm.pl' !== d &&
        a.sendViaSDK &&
        a.webtrekkSDKCallback.isActive_()
          ? a.webtrekkSDKCallback.add_(b)
          : a.requestQueueActivated
            ? ((d = a.trackId.split(',')[0]),
              'undefined' === typeof a.requestQueue[d] &&
                (a.requestQueue[d] = new na(
                  d,
                  {
                    activated: a.requestQueueActivated,
                    ttl: a.requestQueueTTL,
                    resendInterval: a.requestQueueResendInterval,
                    size: a.requestQueueSize,
                    retries: a.requestQueueRetries,
                    retriesOption: a.requestQueueRetriesOption,
                  },
                  a,
                )),
              a.requestQueue[d].add_(b))
            : a.invokeImage(
                b,
                function (b, d, c) {
                  a._requestLoadHandler(b, d, c);
                },
                a.simulatedRequestTimeout,
              );
      };
    },
    qa = function (a) {
      var c = {},
        b = 0,
        d = '';
      a._ps = function (f, e) {
        if ('undefined' === typeof c[f]) {
          c[f] = e;
          f = Object.keys(c).sort(function (a, b) {
            return parseInt(b) - parseInt(a);
          });
          b = 0;
          e = [];
          for (var g = 0; g < f.length; g++)
            (b += parseInt(f[g])), e.push(c[f[g]]);
          d = '';
          try {
            d = a.simpleEncode(b + '', e.join(';'));
          } catch (k) {}
        }
      };
      a._gps = function () {
        return { id_: b, version_: d };
      };
      a._ps(8192, a.version.split('').join('.'));
    };
  A = function (a, c, b) {
    b = new RegExp(c + '=' + b);
    var d = document.location.href;
    c = new Date().getTime();
    b = b.exec(d);
    d = /wt_t=([\d]{13})/.exec(d);
    if (b && 'undefined' !== typeof b[1] && d && 'undefined' !== typeof d[1]) {
      d = parseInt(d[1]) + 9e5;
      if (!a.maxURLParameterValidity || c + a.maxURLParameterValidity < d)
        return !1;
      if (d > c) return a.wtUnescape(b[1]);
    }
    return !1;
  };
  var G = function (a) {
      var c = a.trackId.split(',')[0],
        b = 'number' === typeof a.cookieEidTimeout ? a.cookieEidTimeout : 6,
        d = a.generateEid(),
        f = '',
        e = '',
        g = [],
        k = -1,
        h = '',
        p = !1,
        n = d,
        m = !1,
        r = !1,
        q = function (d) {
          b
            ? a.setCookie('wt3_eid', g.join(';'), 43200 * b, d)
            : a.setCookie('wt3_eid', g.join(';'));
        },
        v = function (b, d, c) {
          for (
            var e = !1,
              f = a.getCookie('wt3_eid').split(';'),
              k = 0,
              x = f.length;
            k < x;
            k++
          )
            if (-1 !== f[k].indexOf(d + '|')) {
              e = !0;
              f[k] = d + '|' + b;
              break;
            }
          e || f.push(d + '|' + b);
          g = f;
          q(c);
        },
        t = function (a) {
          if (a && '2' === a.substring(0, 1)) {
            a = parseInt(a.substring(1, 11) + '000');
            a = new Date(a);
            var b = a.getFullYear() + '';
            b += 10 > a.getMonth() + 1 ? '0' : '';
            b += a.getMonth() + 1;
            b += 10 > a.getDate() ? '0' : '';
            b += a.getDate();
            b += 10 > a.getHours() ? '0' : '';
            b += a.getHours();
            b += 10 > a.getMinutes() ? '0' : '';
            return (b += a.getMinutes());
          }
          return '';
        };
      this.init = function () {
        g = a.getCookie('wt3_eid').split(';');
        for (var b = 0; b < g.length; b++)
          if (-1 !== g[b].indexOf(c + '|')) {
            k = b;
            e = g[b];
            h = e.replace(c + '|', '').split('#')[0];
            -1 !== e.indexOf('#') && (n = e.replace(c + '|', '').split('#')[1]);
            break;
          }
        f = A(a, 'wt_eid', '([\\d]{19})');
        'string' === typeof l.webtrekkApplicationEverId
          ? (f = l.webtrekkApplicationEverId)
          : 'object' === typeof l.WebtrekkAndroidWebViewCallback &&
            (f = l.WebtrekkAndroidWebViewCallback.getEverId());
        h
          ? (f && ((g[k] = c + '|' + f), (h = f), (a.updateCookie = !0)),
            'undefined' !== typeof l.wt_mcp_eid && (p = !0),
            -1 === g[k].indexOf('#')
              ? (g[k] += '#' + d)
              : (g[k] = e.replace(/#[0-9]{19}/g, '#' + d)),
            a.updateCookie ? q() : (m = n = !1))
          : ('string' === typeof l.wt_mcp_eid &&
            -1 !== l.wt_mcp_eid.indexOf(c + '|')
              ? ((h = l.wt_mcp_eid.replace(c + '|', '')), (p = !0))
              : f
                ? (h = f)
                : ((h = a.generateEid()), (p = !0)),
            g.push(c + '|' + h + '#' + d),
            q());
        if (a.updateCookie)
          a: {
            if (
              ((n = t(n)),
              (m = t(h)),
              (b = h) &&
                '2' === b.substring(0, 1) &&
                ((b = parseInt(b.substring(1, 11))),
                1089676800 < b && 23e8 > b))
            ) {
              r = b + '000';
              break a;
            }
            r = !1;
          }
      };
      this.getId = function () {
        var b;
        if ((b = a.validateEverId))
          (b = h.replace(/^\d((\d){10})\d+$/, '$1')),
            (b = !(1089676800 < parseInt(b)));
        b && ((h = a.generateEid()), v(h, c));
        return h;
      };
      this.setId = function (a, b, d) {
        v(a, b, d);
      };
      this.getUrlId = function () {
        return f;
      };
      this.getLastVisitContact = function () {
        return n;
      };
      this.getFirstVisitContact = function () {
        return m;
      };
      this.getFirstVisitContactTimestamp = function () {
        return r;
      };
      this.getCookieOne = function () {
        return p;
      };
    },
    H = function (a) {
      var c = a.trackId.split(',')[0],
        b = [],
        d = '';
      this.init = function () {
        b = a.getCookie('wt3_sid').split(';');
        for (var f = 0; f < b.length; f++)
          if (-1 !== b[f].indexOf(c)) {
            d = b[f];
            break;
          }
        d || b.push(c);
        a.setCookie('wt3_sid', b.join(';'));
      };
      this.getId = function () {
        return d;
      };
      this.setId = function (b) {
        for (
          var d = !1,
            c = a.getCookie('wt3_sid').split(';'),
            f = 0,
            h = c.length;
          f < h;
          f++
        )
          if (-1 !== c[f].indexOf(b)) {
            d = !0;
            break;
          }
        d || c.push(b);
        a.setCookie('wt3_sid', c.join(';'));
      };
    },
    ra = function (a) {
      var c = !1,
        b = function (a) {
          var b = document.createElement('canvas'),
            d = null;
          try {
            d = b.getContext(a);
          } catch (r) {}
          return d && null !== d;
        },
        d = function (a, b) {
          var d = document.createElement('img');
          d.crossOrigin = 'use-credentials';
          (function (a, b) {
            var d = !1,
              c = function (c, e) {
                if (!d) {
                  d = !0;
                  if (c) {
                    c = document.createElement('canvas');
                    e = c.getContext('2d');
                    c.height = a.height;
                    c.width = a.width;
                    e.drawImage(a, 0, 0);
                    try {
                      var f = e.getImageData(0, 0, 6, 1).data;
                      return b(f);
                    } catch (y) {
                      return b([], '5');
                    }
                  }
                  return b([], e);
                }
                return 0;
              };
            a.onerror = function () {
              c(!1, '4');
            };
            a.onload = function () {
              c(!0);
            };
            l.setTimeout(function () {
              c(!1, '3');
            }, 2e3);
          })(d, b);
          0 !== a.search(/https:|http:/) && (a = 'https://' + a);
          d.src = a;
        },
        f = function (a) {
          for (var b = '', d = 0, c; d < a.length; d++)
            (c = a[d].toString(16)),
              2 > c.length && (c = '0' + c),
              (b += c),
              2 === d % 4 && d++;
          b = b.substr(0, b.length - 4);
          return 'string' === typeof b &&
            -1 !== b.search(/^[0-9a-f]{32}$/) &&
            -1 === b.search(/^[f]{32}$/)
            ? b
            : '';
        },
        e = function (b) {
          '1' === b
            ? a.setCookie('wt_cdbeid', b, 15)
            : a.setCookie('wt_cdbeid', b);
        },
        g = function (b) {
          ('1' !== a.cookie || ('1' === a.cookie && a.eid)) && 0 < a.pageCounter
            ? l.setTimeout(function () {
                b();
              }, 300)
            : l.setTimeout(function () {
                g(b);
              }, 50);
        },
        k = function (b) {
          g(function () {
            if ('1' === a.cookie) {
              var d =
                'https://fbc.wcfbc.net/v1/fbc' + ('?p=' + a.version + ',0');
              d += '&eid=' + a.wtEscape(a.eid);
              d += '&acc=' + a.wtEscape(a.trackId);
              d += '&t=' + new Date().getTime();
              d += '&err=' + b;
              a.invokeImage(d);
            } else
              for (
                var c = a.trackId.split(','), e = 0, f = c.length;
                e < f;
                e++
              ) {
                var g = 'https://fbc.wcfbc.net/v1/fbc';
                g += '?p=' + a.version + ',0';
                g += '&acc=' + a.wtEscape(c[e]);
                g += '&t=' + new Date().getTime();
                g += '&err=' + b;
                d = 'https://';
                d += a.trackDomain + '/' + a.trackId + '/cc';
                d += '?a=r&c=wteid_' + c[e];
                d += '&t=' + a.wtEscape(g);
                a.invokeImage(d);
              }
          });
        },
        h = function () {
          c = !0;
          if (
            !(
              a.deactivatePixel ||
              a.isSafari ||
              a.isUserIdentificationOptOuted_()
            )
          ) {
            var h = a.getCookie('wt_cdbeid');
            h && -1 !== h.search(/^[0-9a-f]{32}$/) && (a.cdbeid = h);
            h ||
              (a.useCDBCache && !a.isIE && b('2d')
                ? ('string' !== typeof a.useCDBCache &&
                    (a.useCDBCache = 'fbc.wcfbc.net/v1/fbc'),
                  d(a.useCDBCache, function (b, d) {
                    var c = f(b);
                    c
                      ? (e(c),
                        g(function () {
                          a.quicksend(
                            a.wtEscape(a.contentId.split(';')[0]) +
                              ',1,' +
                              a.baseparams(),
                            '&cdbeid=' + c,
                            'cdb',
                          );
                        }))
                      : (e('1'), k(d ? d : '6'));
                  }))
                : ((h = ''),
                  a.useCDBCache && a.isIE
                    ? (h = '1')
                    : a.useCDBCache && !b('2d') && (h = '2'),
                  e('1'),
                  k(h)));
          }
        };
      a.cdbeid = !1;
      a.setProperty('execCDB', !1);
      a.setProperty('useCDBCache', !1);
      a.startCDB = function () {
        c || ((a.execCDB = !0), h());
      };
      a.execCDB && h();
    },
    sa = function (a, c, b) {
      a.eid = !1;
      a.firstVisitContact = !1;
      a.firstVisitTimestamp = !1;
      a.lastVisitContact = !1;
      a.cookieOne = !1;
      a.setProperty('globalVisitorIds', !1);
      a.setProperty('validateEverId', !1);
      a.setProperty('maxURLParameterValidity', 9e5);
      a.zeroPad = function (a, b) {
        for (var d = '', c = 0; c <= b; c++) d += '0';
        a = d + a;
        return a.substring(a.length - b, a.length);
      };
      a.generateEid = function () {
        var b = Math.floor(new Date().getTime() / 1e3);
        1089676800 > b &&
          (b =
            '3' +
            a.zeroPad(Math.floor(1e4 * Math.random()), 4) +
            a.zeroPad(Math.floor(1e5 * Math.random()), 5));
        return (
          '2' + a.zeroPad(b, 10) + a.zeroPad(Math.floor(1e8 * Math.random()), 8)
        );
      };
      a.setEverId = function (b, c, e) {
        b &&
          'string' === typeof b &&
          -1 !== b.search(/^[0-9]{19}$/) &&
          ((c && 'string' === typeof c) || (c = a.trackId.split(',')[0]),
          new G(a).setId(b, c, e),
          new H(a).setId(c));
      };
      a.firstParty = function () {
        if (!a.isUserIdentificationOptOuted_()) {
          var b = new G(a);
          b.init();
          var c = new H(a);
          c.init();
          a.eid = b.getId();
          a.cookieOne = b.getCookieOne();
          c.getId() ||
            (b.getId() !== b.getUrlId() && (a.forceNewSession = !0),
            (a.firstVisitContact = b.getFirstVisitContact()),
            (a.lastVisitContact = b.getLastVisitContact()));
          a.firstVisitTimestamp = b.getFirstVisitContactTimestamp();
        }
      };
      a.globalVisitorIds && (c.execCDB = !0);
      ra(a, c, b);
    },
    ta = function (a) {
      a.overlayOn =
        '1' === a.urlParam(a.wtHref(), 'wt_overlay', '0') ||
        '1' === a.getCookie('wt_overlay');
      var c = function () {
        'undefined' !== typeof l.wt_overlay
          ? l.setTimeout(function () {
              l.wt_overlay();
            }, 1e3)
          : ('undefined' === typeof l.wt_overlay_retry &&
              (l.wt_overlay_retry = 0),
            l.wt_overlay_retry++,
            60 > l.wt_overlay_retry &&
              l.setTimeout(function () {
                c();
              }, 1e3));
      };
      '0' === a.urlParam('wt_overlay') &&
        ((a.overlayOn = !1), a.setCookie('wt_overlay', '', -3600));
      a.overlayOn &&
        !a.disableOverlayView &&
        (a.setCookie('wt_overlay', '1'), a.startOverlay('overlay', c));
    },
    ua = function (a, c, b) {
      a.setProperty('reporturl', 'report2.webtrekk.de/cgi-bin/wt');
      a.setProperty('disableOverlayView', !1);
      var d = function (b) {
        var d = a.reporturl;
        -1 !==
          b.search(
            /^((http[s]?:\/\/)?(report\d+|analytics)\.webtrekk\.(com|de)\/)/,
          ) && ((d = b.split('/')), d.pop(), (d = d.join('/')));
        return d;
      };
      a.searchContentIds = function () {
        var b = 0,
          d = 0;
        a.contentIds = a.wtEscape(a.contentId.split(';')[0]);
        do {
          b++;
          var c = a.urlParam(document.location.href, 'wt_contentId' + b, !1);
          c &&
            ((a.contentIds += '&wt_contentId' + b + '=' + a.wtEscape(c)), d++);
        } while (d >= b);
      };
      a.startOverlay = function (b, c) {
        a.searchContentIds();
        a.urlParam(a.wtHref(), 'wt_reporter', !1)
          ? (a.reporturl = d(a.urlParam(a.wtHref(), 'wt_reporter', !1)))
          : a.getCookie('wt_overlayFrame') &&
            (a.reporturl = d(a.getCookie('wt_overlayFrame')));
        -1 === a.reporturl.search(/http|https/) &&
          (a.reporturl = document.location.protocol + '//' + a.reporturl);
        if (
          a.contentIds &&
          ((b =
            a.reporturl +
            '/' +
            b +
            '.pl?wt_contentId=' +
            a.contentIds +
            '&x=' +
            new Date().getTime()),
          a.include(b))
        )
          if ('complete' !== document.readyState) a.registerEvent(l, 'load', c);
          else return c();
        return 0;
      };
      (function () {
        for (var b = !1, d = 0; d < l.webtrekkUnloadObjects.length; d++)
          a === l.webtrekkUnloadObjects[d] && (b = !0);
        b || l.webtrekkUnloadObjects.push(a);
        ta(a);
      })();
    },
    va = function () {
      var a = this,
        c =
          'customClickParameter customSessionParameter customCampaignParameter customEcommerceParameter customParameter crmCategory urmCategory contentGroup productCategory'.split(
            ' ',
          ),
        b = {
          numberSearchResults: [c[4], 771],
          errorMessages: [c[4], 772],
          loginStatus: [c[1], 800],
          pixelVersion: [c[1], 801],
          trackingPlatform: [c[1], 802],
          npsScore: [c[6], 850],
          npsScoreFeedback: [c[6], 851],
          productLabel: [c[8], 870],
          productMainCategory: [c[8], 871],
          productSubCategory: [c[8], 872],
          productManufacturer: [c[8], 873],
          productShortDescription: [c[8], 874],
          productLongDescription: [c[8], 875],
          paymentMethod: [c[3], 761],
          shippingService: [c[3], 762],
          shippingSpeed: [c[3], 763],
          shippingCosts: [c[3], 764],
          grossMargin: [c[3], 765],
          orderStatus: [c[3], 766],
          productVariant: [c[3], 767],
          couponValue: [c[3], 563],
          productSoldOut: [c[3], 760],
          paywall: [c[4], 773],
          articleTitle: [c[4], 774],
          paywallUser: [c[6], 852],
          pageMainCategory: [c[7], 880],
          pageSubCategory: [c[7], 881],
          pageAuthor: [c[7], 882],
          contentTags: [c[4], 775],
          pageTitle: [c[4], 776],
          pageType: [c[4], 777],
          pageLength: [c[4], 778],
          daysSincePublication: [c[4], 779],
          testVariant: [c[4], 781],
          testExperiment: [c[4], 782],
          email: [c[6], 700],
          emailRID: [c[6], 701],
          emailOptin: [c[6], 702],
          firstName: [c[6], 703],
          lastName: [c[6], 704],
          telefon: [c[6], 705],
          gender: [c[6], 706],
          birthday: [c[6], 707],
          country: [c[6], 708],
          city: [c[6], 709],
          postalCode: [c[6], 710],
          street: [c[6], 711],
          streetNumber: [c[6], 712],
          validation: [c[6], 713],
        },
        d = {},
        f = function () {
          for (var a = 0; a < c.length; a++) d[c[a]] = {};
        };
      f();
      this.list = {};
      this.clear = function () {
        d = {};
        a.list = {};
        f();
      };
      this.get = function (b) {
        b =
          'all' === b ? d : 'undefined' !== typeof a.list[b] ? a.list[b] : null;
        return b;
      };
      this.put = function (c, f) {
        if (f && 'undefined' !== typeof b[c]) {
          var e = b[c];
          'undefined' === typeof d[e[0]] && (d[e[0]] = {});
          d[e[0]][e[1]] = f;
          a.list[c] = f;
        }
        return a;
      };
      this.remove = function (c) {
        var e = null;
        if ('undefined' !== typeof b[c]) {
          var f = b[c];
          'undefined' !== typeof d[f[0]] &&
            'undefined' !== typeof d[f[0]][f[1]] &&
            ((e = d[f[0]][f[1]]), delete d[f[0]][f[1]]);
          delete a.list[c];
        }
        return e;
      };
    },
    wa = function (a) {
      a.PredefinedParameter = va;
      a.checkCustomParameter = function (c, b) {
        var d = '';
        if ('object' === typeof c)
          for (var f in c)
            isNaN(parseInt(f)) ||
              'undefined' === typeof c[f] ||
              'string' !== typeof c[f] ||
              '' === c[f] ||
              (a.checkSC('custom') && (c[f] = a.decrypt(c[f])),
              -1 === a.paramFirst.indexOf(b + f + ';') &&
                (d += '&' + b + f + '=' + a.wtEscape(c[f])));
        return d;
      };
      a.mergeCustomParameter = function (a, b) {
        a || (a = {});
        for (var d in b) a[d] = b[d];
        return a;
      };
    },
    xa = function (a, c, b) {
      var d = this;
      d.item = b;
      d.href = 'undefined' !== typeof b.href ? b.href : '';
      d.href ||
        (d.href = a.getAttribute(b, 'href') ? a.getAttribute(b, 'href') : '');
      d.linkIdByNameOrId = a.getAttribute(b, 'name')
        ? a.getAttribute(b, 'name')
        : '';
      d.linkIdByNameOrId ||
        (d.linkIdByNameOrId = a.getAttribute(b, 'id')
          ? a.getAttribute(b, 'id')
          : '');
      d.linkId = '';
      d.action = 'link';
      d.isDownloadFile = !1;
      d.isInternalLink = function () {
        if (a.linkTrackDownloads) {
          var c = a.linkTrackDownloads.split(';');
          var e = d.href.split('.');
          e = e.pop();
          for (var g = 0; g < c.length; g++)
            if (c[g] === e) {
              d.isDownloadFile = !0;
              break;
            }
        }
        if (d.isDownloadFile || '_blank' === b.target) d.action = 'click';
        c = d.href;
        e = c.toLowerCase();
        g = c.split('#')[0];
        var k = document.location,
          h = d.item,
          l = a.getAttribute,
          n = l(h, 'onclick'),
          m = l(h, 'onmousedown');
        h = l(h, 'ontouchstart');
        c = a.noDelayLinkTrackAttribute
          ? !!a.getAttribute(b, a.noDelayLinkTrackAttribute)
          : !!(
              !c ||
              0 === e.indexOf('javascript:') ||
              0 === e.indexOf('#') ||
              'click' === d.action ||
              (g === k.href.split('#')[0] && -1 !== c.indexOf('#')) ||
              (g === k.pathname.split('#')[0] && -1 !== c.indexOf('#')) ||
              (n && -1 !== n.search(/return false[;]?$/)) ||
              (m && -1 !== m.search(/return false[;]?$/)) ||
              (h && -1 !== h.search(/return false[;]?$/))
            );
        return c;
      };
      d.getCCParams = function () {
        var b = '';
        if (a.config.customClickParameter) {
          var c =
            'undefined' !==
            typeof a.config.customClickParameter[d.linkIdByNameOrId]
              ? a.config.customClickParameter[d.linkIdByNameOrId]
              : !1;
          c || (c = a.config.customClickParameter);
          for (var g in c)
            !isNaN(parseInt(g)) &&
              'string' === typeof c[g] &&
              c[g] &&
              (a.checkSC('custom') && (c[g] = a.decrypt(c[g])),
              (b += '&ck' + g + '=' + a.wtEscape(c[g])));
        }
        return b;
      };
      d.setJSONParams = function () {
        d.linkId || (d.linkId = a.getAttribute(b, a.linkTrackAttribute));
        null !== a.getJSON(d.linkId) &&
          (a.parseJSON(a.getJSON(d.linkId)), (d.linkId = a.config.linkId));
      };
      d.getLinkId = function () {
        d.linkId = a.getAttribute(b, a.linkTrackAttribute);
        d.setJSONParams();
        if ('link' === a.linkTrack) {
          var c = d.href.indexOf('//');
          d.href = 0 <= c ? d.href.substr(c + 2) : d.href;
          a.linkTrackPattern &&
            (a.linkTrackReplace || (a.linkTrackReplace = ''),
            (d.href = d.href.replace(a.linkTrackPattern, a.linkTrackReplace)));
          d.linkId =
            (d.linkId ? d.linkId + '.' : '') +
            d.href.split('?')[0].split('#')[0].replace(/\//g, '.');
          c = [];
          a.linkTrackParams &&
            (c = a.linkTrackParams.replace(/;/g, ',').split(','));
          for (var e = 0; e < c.length; e++) {
            var g = a.urlParam(d.href, c[e], '');
            g && (d.linkId += '.' + c[e] + '.' + g);
          }
        }
        return d.linkId;
      };
    },
    ya = function (a) {
      var c = this;
      c.triggerObjectName =
        '__' + new Date().getTime() + '_' + parseInt(1e3 * Math.random());
      var b = function (b, d) {
          b = d[c.triggerObjectName];
          a.config = a.getConfig(!0);
          a.config.customClickParameter = a.customClickParameter;
          a.ccParams = b.getCCParams();
          d = a.config.linkId = b.getLinkId();
          a.sendinfo(a.config, d, b.action);
        },
        d = function (d) {
          a.registerEvent(d, 'click', function (e) {
            if ((e.which && 1 === e.which) || (e.button && 1 === e.button))
              !a.delayLinkTrack ||
                e.ctrlKey ||
                e.altKey ||
                e.metaKey ||
                e.shiftKey ||
                'function' !== typeof e.preventDefault ||
                d[c.triggerObjectName].isInternalLink() ||
                (e.preventDefault(),
                l.setTimeout(function () {
                  document.location.href = d.href;
                }, a.delayLinkTrackTime)),
                b(e, d);
          });
        },
        f = function (b) {
          for (var e = 0, f = b.length; e < f; e++) {
            var h = b[e],
              l = a.getAttribute(h, a.linkTrackAttribute),
              n = a.getAttribute(h, 'href');
            ((a.linkTrackIgnorePattern &&
              n &&
              -1 === n.search(a.linkTrackIgnorePattern)) ||
              !a.linkTrackIgnorePattern) &&
              'undefined' === typeof h[c.triggerObjectName] &&
              (l || 'link' === a.linkTrack) &&
              ((h[c.triggerObjectName] = new xa(a, c, h)), d(h));
          }
        };
      c.linkTrackInit = function () {
        if (
          a.linkTrack &&
          ('link' === a.linkTrack || 'standard' === a.linkTrack)
        ) {
          for (var b = !1, d = 0; d < l.webtrekkLinktrackObjects.length; d++)
            a === l.webtrekkLinktrackObjects[d] && (b = !0);
          b || l.webtrekkLinktrackObjects.push(a);
          if (a.linkTrackShadowRoot && a.linkTrackShadowRoot.length)
            for (b = 0, d = a.linkTrackShadowRoot.length; b < d; b++)
              for (
                var c = a.getShadowRootsBySelector(a.linkTrackShadowRoot[b]),
                  h = 0,
                  p = c.length;
                h < p;
                h++
              )
                f(a.getElementsBySelector(c[h], 'a'));
          f(document.links);
        }
      };
    },
    za = function (a) {
      a.linkTrackObject = new ya(a);
      a.linkTrackInstall = a.linkTrackObject.linkTrackInit;
      a.linkTrackInit = a.linkTrackObject.linkTrackInit;
      'complete' === document.readyState
        ? a.linkTrackInit()
        : a.registerEvent(l, 'load', function () {
            a.linkTrackInit();
          });
    },
    I = function (a, c) {
      var b = this,
        d = null,
        f = null;
      b.formObject = !1;
      b.formFocus = !1;
      b.formName = !1;
      b.form = a.form;
      b.formSubmit = !1;
      b.formFieldData = {};
      b.formFieldDataUnused = {};
      b.formFieldDataPathAnalysis = [];
      b.triggerObjectName =
        '__' + new Date().getTime() + '_' + parseInt(1e3 * Math.random() + '');
      var e = function (a) {
          return (
            'hidden' !== a &&
            'button' !== a &&
            'image' !== a &&
            'reset' !== a &&
            'submit' !== a &&
            'fieldset' !== a
          );
        },
        g = function (a) {
          return (
            'select-multiple' !== a &&
            'select-one' !== a &&
            'checkbox' !== a &&
            'radio' !== a
          );
        },
        k = function (d, c) {
          if (a.formPathAnalysis)
            if ('select-multiple' === c.type)
              for (
                var e = b.getFormFieldValue(c).split('|'), f = 0, g = e.length;
                f < g;
                f++
              )
                b.formFieldDataPathAnalysis.push([d, c.type, e[f]]);
            else
              b.formFieldDataPathAnalysis.push([
                d,
                c.type,
                b.getFormFieldValue(c),
              ]);
        },
        h = function (c, e) {
          a.registerEvent(e, 'click', function () {
            if (e !== d) {
              null !== d && k(f, d);
              d = e;
              var a = (f = c);
              b.formObject &&
                ((b.formFocus = a), delete b.formFieldDataUnused[a]);
            }
          });
        },
        p = function () {
          if (b.form && !b.formObject)
            for (var a = document.forms, d = 0, c = a.length; d < c; d++) {
              var e = a[d];
              if ('undefined' !== typeof e.elements.wt_form) {
                b.formObject = e;
                break;
              }
            }
        },
        n = function (a) {
          !b.form ||
            (a.target !== b.formObject && a.srcElement !== b.formObject) ||
            (b.formSubmit = !0);
        },
        m = function () {
          p();
          if (b.formObject) {
            var d = a.getAttribute(b.formObject, a.formAttribute);
            b.formName = d ? d : a.contentId.split(';')[0];
            d = 0;
            for (var f = b.formObject.elements, g = f.length; d < g; d++) {
              var k = f[d],
                m = b.getFormFieldName(k);
              e(k.type) &&
                m &&
                ('undefined' === typeof b.formFieldData[m] &&
                  (b.formFieldData[m] = []),
                'undefined' === typeof b.formFieldDataUnused[m] &&
                  (b.formFieldDataUnused[m] = []),
                b.formFieldData[m].push(k),
                b.formFieldDataUnused[m].push(k),
                h(m, k));
            }
            a.registerEvent(b.formObject, 'submit', n);
            a.registerEvent(l, 'beforeunload', function () {
              c(b);
            });
            a.registerEvent(l, 'unload', function () {
              c(b);
            });
          }
        },
        r = function (d) {
          var c = [];
          a.formFullContent && (c = a.formFullContent.split(';'));
          if (a.formAnonymous || g(d.type)) {
            for (var e = 0; e < c.length; e++)
              if (c[e] === b.getFormFieldName(d)) return !1;
            return !0;
          }
          return !1;
        },
        q = function (b, d) {
          d || (d = b);
          var c = a
            .getAttribute(d, a.formValueAttribute)
            .replace(/[.;|]/g, '_');
          return g(b.type)
            ? a.maxlen(a.wtUnescape(d.value), 110)
            : r(b)
              ? 'anon'
              : a.maxlen(a.wtUnescape(c), 110);
        },
        v = function (a, d, c, e) {
          var f = a.replace(/[.;|]/g, '_') + '.';
          f = f + (d + '|') + (c + '|');
          return (f = e
            ? f + '0'
            : f + (b.formFocus && b.formFocus === a ? '1' : '0'));
        },
        t = function (a, b) {
          for (var d = [], c = 0, e = b.length; c < e; c++)
            if ('undefined' !== typeof a[b[c]])
              if ('select-multiple' === a[b[c]][0])
                for (
                  var f = a[b[c]][1].split('|'), g = 0, h = f.length;
                  g < h;
                  g++
                )
                  d.push(v(b[c], a[b[c]][0], f[g]));
              else d.push(v(b[c], a[b[c]][0], a[b[c]][1]));
          return d.join(';');
        },
        u = function (a) {
          for (var d in a) {
            var c = d + '';
            if (1 < a[c].length) {
              for (var e = !1, f = 0; f < a[c].length; f++) {
                var g = b.getFormFieldValue(a[c][f]);
                if ('empty' !== g) {
                  a[c] = [a[c][f].type, g];
                  e = !0;
                  break;
                }
              }
              e || (a[c] = [a[c][0].type, 'empty']);
            } else a[c] = [a[c][0].type, b.getFormFieldValue(a[c][0])];
          }
        },
        w = function () {
          if (!b.formObject) return '';
          u(b.formFieldData);
          u(b.formFieldDataUnused);
          var d = [];
          var c = [];
          if ('undefined' !== typeof b.formObject.elements.wt_fields) {
            var e = b.formObject.elements.wt_fields.value;
            e && (c = e.split(';'));
          }
          if (0 >= c.length)
            for (var f in b.formFieldData)
              (e = f + ''), 'string' === typeof e && e && c.push(e);
          f = !1;
          if (a.formPathAnalysis) {
            (e = t(b.formFieldDataUnused, c)) && d.push(e);
            e = 0;
            for (var g = b.formFieldDataPathAnalysis.length; e < g; e++) {
              var h = b.formFieldDataPathAnalysis;
              a: {
                var k = 0;
                for (var l = c.length; k < l; k++)
                  if (h[e][0] === c[k]) {
                    k = !0;
                    break a;
                  }
                k = !1;
              }
              k && ((f = !0), d.push(v(h[e][0], h[e][1], h[e][2], !0)));
            }
            f &&
              ((c = d[d.length - 1]),
              (c = c.substr(0, c.length - 1)),
              (d[d.length - 1] = c + '1'));
          } else return t(b.formFieldData, c);
          return d.join(';');
        };
      b.getFormFieldName = function (b) {
        var d = b.name;
        a.formFieldAttribute &&
          ((d = ''),
          (b = a.getAttribute(b, a.formFieldAttribute)) || null !== b) &&
          (d = b);
        return d;
      };
      b.getFormFieldValue = function (d) {
        var c = d.type,
          e = '';
        if ('select-multiple' === c) {
          e = [];
          for (var f = 0, g = d.options, h = g.length; f < h; f++)
            g[f].selected && e.push(q(d, g[f]));
          0 >= e.length && e.push('empty');
          e = e.join('|');
        } else
          'select-one' === c
            ? ((e = ''),
              -1 !== d.selectedIndex &&
                ((e = q(d, d.options[d.selectedIndex])) || (e = 'empty')))
            : 'checkbox' === c || 'radio' === c
              ? d.checked
                ? (e = q(d)) || (e = 'checked')
                : (e = 'empty')
              : 'hidden' !== c &&
                'button' !== c &&
                'image' !== c &&
                'reset' !== c &&
                'submit' !== c &&
                ((f = (e = q(d)) ? 'filled_out' : 'empty'),
                r(d) || (f = e),
                (g = b.getFormFieldName(d)),
                'undefined' !== typeof a.formFieldDefaultValue[g] &&
                  a.formFieldDefaultValue[g] === e &&
                  'empty' !== f &&
                  (f = 'empty'),
                f || (f = 'empty'),
                (e = f));
        return r(d) &&
          'select-multiple' !== c &&
          'empty' !== e &&
          'filled_out' !== e
          ? 'anon'
          : e;
      };
      b.formTrackInstall = function (a) {
        b.formObject = a ? a : document.forms[0] ? document.forms[0] : !1;
        b.formObject && ((b.form = '1'), m());
      };
      b.getFormTrackingData = function () {
        var c = '';
        if (b.formObject) {
          null !== d && k(f, d);
          var e = w();
          if (e) {
            var g = b.formSubmit;
            a.formSubmit && (g = a.formSubmit);
            c += '&fn=' + a.wtEscape(b.formName) + '%7C' + (g ? '1' : '0');
            c += '&ft=' + a.wtEscape(e);
          }
          b.formSubmit = !1;
          a.formSubmit = !1;
          b.formName = !1;
          b.formObject = !1;
          b.formFocus = !1;
          b.formFieldData = {};
          b.formFieldDataUnused = {};
          b.formFieldDataPathAnalysis = [];
        }
        return c;
      };
      b.formTrackSubmit = function () {
        b.formSubmit = !0;
      };
      b.sendFormRequest = function () {
        '1' !== a.cookie || a.optOut || a.deactivatePixel || a.firstParty();
        'function' === typeof a.beforeUnloadPixel
          ? a.beforeUnloadPixel()
          : a.executePlugin(a.getPluginConfig('form', 'before'));
        var d = b.getFormTrackingData();
        d &&
          a.quicksend(
            a.wtEscape(a.contentId.split(';')[0]) + ',1,' + a.baseparams(),
            d,
          );
        'function' === typeof a.afterUnloadPixel
          ? a.afterUnloadPixel()
          : a.executePlugin(a.getPluginConfig('form', 'after'));
      };
      b.updateFormFieldStatus = function (a) {
        if (a && 'undefined' !== typeof a.type) {
          var d = a.type,
            c = b.getFormFieldName(a),
            e = b.getFormFieldValue(a);
          c &&
            e &&
            'undefined' !== typeof b.formFieldData[c] &&
            (b.formFieldData[c].splice(0, 0, a),
            b.formFieldDataPathAnalysis.push([c, d, e]),
            (b.formFocus = c),
            delete b.formFieldDataUnused[c]);
        }
      };
      b.init = function () {
        b.form && '1' === b.form && !b.formObject && m();
        return b;
      };
    },
    Aa = function (a) {
      a.multipleFormArray = [];
      var c = function (b) {
          for (var d = 0; d < a.multipleFormArray.length; d++)
            if (a.multipleFormArray[d].formObject === b)
              return a.multipleFormArray[d];
          return !1;
        },
        b = function (b) {
          if (b && 'undefined' !== typeof b.elements && !c(b)) {
            var d = new I(a, function (b) {
              C(a, 'form', 'form', b);
            });
            a.multipleFormArray.push(d);
            d.formTrackInstall(b);
          }
        };
      a.multipleFormTrackInstall = b;
      a.multipleFormTrackInit = b;
      a.multipleFormTrackSubmit = function (a) {
        a && (a = c(a)) && a.formTrackSubmit();
      };
      a.sendMultipleFormRequest = function (b) {
        if (b) (b = c(b)) && b.sendFormRequest();
        else
          for (b = 0; b < a.multipleFormArray.length; b++)
            a.multipleFormArray[b].sendFormRequest();
      };
      a.updateMultipleFormFieldStatus = function (a, b) {
        a && (a = c(a)) && a.updateFormFieldStatus(b);
      };
    },
    Ba = function (a, c) {
      var b = this;
      b.name = a ? a : '';
      b.elements = c ? c : [];
      b.add = function (a) {
        a && null !== a && b.elements.push(a);
        return b;
      };
      b.getAttribute = function () {
        return a;
      };
      b.addEventListener = b.removeEventListener = function () {};
    };
  C = function (a, c, b, d) {
    '1' !== a.cookie || a.optOut || a.deactivatePixel || a.firstParty();
    (b = b ? b : '') || (b = a.formObject && 'noForm' !== c ? 'form' : 'link');
    'function' === typeof a.beforeUnloadPixel
      ? a.beforeUnloadPixel()
      : 'form' === b && a.executePlugin(a.getPluginConfig('form', 'before'));
    var f = '';
    if (
      a.config.linkId &&
      (f += '&ct=' + a.wtEscape(a.maxlen(a.wtUnescape(a.config.linkId), 255)))
    ) {
      var e = a.ccParams;
      'string' === typeof e && '' !== e && (f += e);
    }
    if (a.wtEp)
      if (a.wtEpEncoded) f += a.wtEp;
      else if (((e = a.wtEp), 'string' === typeof e && '' !== e)) {
        e = e.split(/;/);
        for (var g = 0; g < e.length; g++)
          if ('undefined' !== typeof e[g]) {
            var k = e[g].split(/=/);
            a.checkSC('custom') && (k[1] = a.decrypt(k[1]));
            k[1] = a.wtEscape(k[1]);
            f += '&' + k[0] + '=' + k[1];
          }
      }
    'noForm' !== c && (f += d.getFormTrackingData());
    '' !== f &&
      (a.quicksend(
        a.wtEscape(a.contentId.split(';')[0]) + ',1,' + a.baseparams(),
        f,
      ),
      (a.config.linkId = ''),
      (a.ccParams = ''),
      (a.wtEp = ''));
    'function' === typeof a.afterUnloadPixel
      ? a.afterUnloadPixel()
      : 'form' === b && a.executePlugin(a.getPluginConfig('form', 'after'));
  };
  var Ca = function (a) {
      a.formTrackObject = new I(a, function (c) {
        C(a, 'form', 'form', c);
      });
      a.formTrackInstall = a.formTrackObject.formTrackInstall;
      a.formTrackInit = a.formTrackObject.formTrackInstall;
      a.formTrackSubmit = a.formTrackObject.formTrackSubmit;
      a.sendFormRequest = a.formTrackObject.sendFormRequest;
      a.updateFormFieldStatus = a.formTrackObject.updateFormFieldStatus;
      'complete' === document.readyState
        ? a.formTrackObject.init()
        : a.registerEvent(l, 'load', function () {
            a.formTrackObject.init();
          });
      a.CustomForm = Ba;
      Aa(a);
    },
    Da = function () {
      var a = '',
        c = '',
        b = !1,
        d = !0,
        f = 0,
        e = null,
        g = !1,
        k = function () {},
        h = function () {},
        p = function (a, b, c) {
          a.addEventListener
            ? a.addEventListener(b, c, !1)
            : a.attachEvent && a.attachEvent('on' + b, c);
        },
        n = function () {
          var a = 1e3;
          e = l.setInterval(function () {
            0 >= a &&
              (l.clearInterval(e), (g = !1), b || ((d = !0), f++, k(f)));
            a -= 5;
          }, 5);
        };
      this.isPageHidden = function () {
        return b;
      };
      this.isPageVisible = function () {
        return d;
      };
      this.setVisibleCall = function (a) {
        k = a;
      };
      this.setHiddenCall = function (a) {
        h = a;
      };
      this.resetCounter = function () {
        f = 1;
      };
      'undefined' !== typeof document.hidden
        ? ((a = 'hidden'), (c = 'visibilitychange'))
        : 'undefined' !== typeof document.mozHidden
          ? ((a = 'mozHidden'), (c = 'mozvisibilitychange'))
          : 'undefined' !== typeof document.msHidden
            ? ((a = 'msHidden'), (c = 'msvisibilitychange'))
            : 'undefined' !== typeof document.oHidden
              ? ((a = 'oHidden'), (c = 'ovisibilitychange'))
              : 'undefined' !== typeof document.webkitHidden &&
                ((a = 'webkitHidden'), (c = 'webkitvisibilitychange'));
      a &&
        ((b = document[a]),
        (d = !b) && f++,
        (function () {
          p(document, c, function () {
            (b = document[a])
              ? (l.clearInterval(e), (d = g = !1), h())
              : g || ((g = !0), n());
          });
        })());
    },
    Ea = function (a) {
      a.setProperty('tabBrowsing', !1);
      var c = [],
        b = [],
        d = null;
      a.replaceRequestTimestamp = function (a) {
        return a.replace(/,\d{13},/, ',' + Date.now() + ',');
      };
      a.replaceUserIdentification = function (b) {
        var c = b;
        try {
          a.enableAnonymousFunction &&
            (a.isUserIdentificationOptOuted_()
              ? ((c = c.replace(/[&?]eid=\d{19}/, '')),
                (c = c.replace(/[&?]one=[01]/, '')),
                (c = c.replace(/[&?]fns=[01]/, '')),
                -1 === c.search(/[&?]nc=1/) && (c += '&nc=1'))
              : ((c = c.replace(/[&?]nc=1/, '')),
                '1' === a.cookie &&
                  -1 === c.search(/[&?]eid=\d{19}/) &&
                  (a.firstParty(), (c += '&eid=' + a.eid))),
            -1 === c.search(/\?/) && (c = c.replace(/&/, '?')));
        } catch (k) {
          c = b;
        }
        return c;
      };
      var f = function () {
        d = new Da();
        d.setVisibleCall(function (e) {
          if (1 < e && 0 < b.length) {
            b[0] = a.replaceRequestTimestamp(b[0]);
            b[0] = a.replaceUserIdentification(b[0]);
            var f = b[0].split('&');
            --e;
            f[1] = 'tb=' + e + '&cp770=' + e + '&' + f[1];
            a.sendPixel(f.join('&'), b[1]);
          }
          for (var k = 0, h = c.length; k < h; k++)
            (f = a.replaceRequestTimestamp(c[k][0])),
              (f = a.replaceUserIdentification(f)),
              (e = c[k][1]),
              a.sendPixel(f, e),
              -1 !== e.indexOf('wt') &&
                -1 === f.search(/[&\?](ct|fn|ft)=.+&?/) &&
                (d.resetCounter(), (b = [f, e]));
          c = [];
        });
      };
      a.tabBrowsing && f();
      a.sendTabBrowsingPixel = function (e, f) {
        d.isPageVisible()
          ? (a.sendPixel(e, f),
            -1 !== f.indexOf('wt') &&
              -1 === e.search(/[&\?](ct|fn|ft)=.+&?/) &&
              (d.resetCounter(), (b = [e, f])))
          : c.push([e, f]);
      };
      a.startTabBrowsing = function () {
        null === d && ((a.tabBrowsing = !0), f());
      };
    };
  l.webtrekkV3 = l.WebtrekkV3 = function (a) {
    var c = l.webtrekkConfig;
    a || (a = l.webtrekkConfig);
    this.version = '460';
    for (
      var b = [R, ca, da, ha, la, pa, sa, qa, ua, wa, za, Ca, Ea], d = 0;
      d < b.length;
      d++
    )
      b[d](this, a, c);
  };
})(window);

if (
  'object' === typeof webtrekkConfig &&
  'object' === typeof webtrekkConfig.safetag &&
  -1 === document.cookie.indexOf('wt_r=1')
) {
  var wts = wts || [],
    wt_safetagConfig = {
      async:
        'undefined' !== typeof webtrekkConfig.safetag.async
          ? webtrekkConfig.safetag.async
          : !0,
      timeout:
        'undefined' !== typeof webtrekkConfig.safetag.timeout
          ? webtrekkConfig.safetag.timeout
          : 2e3,
      safetagDomain:
        'undefined' !== typeof webtrekkConfig.safetag.safetagDomain
          ? webtrekkConfig.safetag.safetagDomain
          : !1,
      safetagId:
        'undefined' !== typeof webtrekkConfig.safetag.safetagId
          ? webtrekkConfig.safetag.safetagId
          : !1,
      customDomain:
        'undefined' !== typeof webtrekkConfig.safetag.customDomain
          ? webtrekkConfig.safetag.customDomain
          : !1,
      customPath:
        'undefined' !== typeof webtrekkConfig.safetag.customPath
          ? webtrekkConfig.safetag.customPath
          : !1,
      option:
        'undefined' !== typeof webtrekkConfig.safetag.option
          ? webtrekkConfig.safetag.option
          : {},
    };
  (function (a, e) {
    var f = function (a) {
        try {
          return encodeURIComponent(a);
        } catch (h) {
          return escape(a);
        }
      },
      d = document.location.protocol;
    if ('http:' === d || 'https:' === d) {
      var b = '';
      a.customDomain && a.customPath
        ? (b = d + '//' + a.customDomain + '/' + a.customPath)
        : a.safetagDomain &&
          a.safetagId &&
          -1 !== a.safetagId.search(/^\d+$/) &&
          (b =
            d +
            '//' +
            a.safetagDomain +
            '/resp/api/get/' +
            a.safetagId +
            '?url=' +
            f(d + '//' + document.location.host + '/'));
      if (b) {
        for (var g in a.option) b += '&' + g + '=' + f(a.option[g]);
        webtrekkV3.prototype.safetag = a;
        webtrekkV3.prototype.safetagInProgress = !0;
        webtrekkV3.prototype.safetagParameter = {};
        webtrekkV3.prototype.update = function () {};
        window.wts = e;
        window.safetagLoaderHandler = function (a, b) {
          a &&
            b &&
            ('onerror' === b
              ? (webtrekkV3.prototype.safetagInProgress = !1)
              : 'onload' === b
                ? ('undefined' === typeof window.wt_r ||
                    isNaN(window.wt_r) ||
                    ((a = new Date()),
                    (document.cookie =
                      'wt_r=1;path=/;expires=' +
                      a.toUTCString(
                        a.setTime(a.getTime() + 1e3 * parseInt(wt_r)),
                      ))),
                  (webtrekkV3.prototype.safetagInProgress = !1))
                : 'onreadystatechange' !== b ||
                  ('loaded' !== a.readyState && 'complete' !== a.readyState) ||
                  ((a.onreadystatechange = null), a.onload(c)));
        };
        if (
          a.async ||
          'complete' === document.readyState ||
          'interactive' === document.readyState
        ) {
          e = document.getElementsByTagName('script')[0];
          var c = document.createElement('script');
          c.async = a.async;
          c.type = 'text/javascript';
          c.onerror = function () {
            'undefined' !== typeof window.wt_mcp_hide &&
              'function' === typeof window.wt_mcp_hide.show &&
              (window.wt_mcp_hide.show(),
              (window.wt_mcp_hide.show = function () {}));
            safetagLoaderHandler(c, 'onerror');
          };
          c.onload = function () {
            safetagLoaderHandler(c, 'onload');
          };
          c.onreadystatechange = function () {
            safetagLoaderHandler(c, 'onreadystatechange');
          };
          c.src = b;
          e.parentNode.insertBefore(c, e);
        } else
          (a =
            '<script type="text/javascript" src="' +
            b +
            '" onerror="safetagLoaderHandler(this,\'onerror\')" onload="safetagLoaderHandler(this,\'onload\')"'),
            (a +=
              ' onreadystatechange="safetagLoaderHandler(this,\'onreadystatechange\')"'),
            (a += '>\x3c/script>'),
            document.write(a);
      }
    }
  })(wt_safetagConfig, wts);
}

/** End webtrekk_v4.js */
